import { RemoteDiagnosticsGetVddListByComChannelGeneric } from '../remote-diagnostics.model';
import { LogicalLinkVddList } from './mockedVddList.model';

export class LL_0002_HMU_CAN01 implements LogicalLinkVddList {
  vddList(): RemoteDiagnosticsGetVddListByComChannelGeneric {
    return {
      service: 'DS_ReadDataByIdent',
      ecu: 'LL_0002_HMU_CAN01',
      type: 'ListOfVDDsByBaseVariant',
      structure: [
        {
          semantic: '',
          path: 'PA_DataIdent',
          unit: '',
          translationid: '',
          dopname: '2 Byte Text Table VDD-Greenbook',
          name: 'PA_DataIdent',
          value: 'ObjectDetails',
          structure: [
            {
              TI_texttableentry: 'TI_BusIdentification',
              isRead: 'true',
              interval: '256',
              texttableentry: 'BusIdentification',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_StatusDtcList',
              isRead: 'true',
              interval: '257',
              texttableentry: 'StatusDtcList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_StatusDtcHistory',
              isRead: 'true',
              interval: '258',
              texttableentry: 'StatusDtcHistory',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_InfoDtcList',
              isRead: 'true',
              interval: '259',
              texttableentry: 'InfoDtcList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_InfoDtcHistory',
              isRead: 'true',
              interval: '260',
              texttableentry: 'InfoDtcHistory',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ServiceDtcList',
              isRead: 'true',
              interval: '261',
              texttableentry: 'ServiceDtcList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ServiceDtcHistory',
              isRead: 'true',
              interval: '262',
              texttableentry: 'ServiceDtcHistory',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_WarningDtcList',
              isRead: 'true',
              interval: '263',
              texttableentry: 'WarningDtcList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_WarningDtcHistory',
              isRead: 'true',
              interval: '264',
              texttableentry: 'WarningDtcHistory',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ErrorDtcList',
              isRead: 'true',
              interval: '265',
              texttableentry: 'ErrorDtcList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ErrorDtcHistory',
              isRead: 'true',
              interval: '266',
              texttableentry: 'ErrorDtcHistory',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FlowTemperatureSensor',
              isRead: 'true',
              interval: '268',
              texttableentry: 'FlowTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterSensor',
              isRead: 'true',
              interval: '271',
              texttableentry: 'DomesticHotWaterSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterFlowSensor',
              isRead: 'true',
              interval: '272',
              texttableentry: 'DomesticHotWaterFlowSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SolarRoofTemperatureSensor',
              isRead: 'true',
              interval: '273',
              texttableentry: 'SolarRoofTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_OutsideTemperatureSensor',
              isRead: 'true',
              interval: '274',
              texttableentry: 'OutsideTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SolarBottomTemperatureSensor',
              isRead: 'true',
              interval: '275',
              texttableentry: 'SolarBottomTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BufferBottomTemperatureSensor',
              isRead: 'true',
              interval: '277',
              texttableentry: 'BufferBottomTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BufferMidBottomTemperatureSensor',
              isRead: 'true',
              interval: '278',
              texttableentry: 'BufferMidBottomTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BufferMidTemperatureSensor',
              isRead: 'true',
              interval: '279',
              texttableentry: 'BufferMidTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BufferTopTemperatureSensor',
              isRead: 'true',
              interval: '281',
              texttableentry: 'BufferTopTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HydraulicSeparatorTemperatureSensor',
              isRead: 'true',
              interval: '282',
              texttableentry: 'HydraulicSeparatorTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HydraulicSeparatorReturnTemperatureSensor',
              isRead: 'true',
              interval: '283',
              texttableentry: 'HydraulicSeparatorReturnTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitFlowTemperatureSensor',
              isRead: 'true',
              interval: '284',
              texttableentry: 'MixerOneCircuitFlowTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitFlowTemperatureSensor',
              isRead: 'true',
              interval: '286',
              texttableentry: 'MixerTwoCircuitFlowTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitFlowTemperatureSensor',
              isRead: 'true',
              interval: '288',
              texttableentry: 'MixerThreeCircuitFlowTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitFlowTemperatureSensor',
              isRead: 'true',
              interval: '290',
              texttableentry: 'MixerFourCircuitFlowTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_WaterPressureSensor',
              isRead: 'true',
              interval: '318',
              texttableentry: 'WaterPressureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FlueGasTemperatureSensor',
              isRead: 'true',
              interval: '331',
              texttableentry: 'FlueGasTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitRoomTemperatureSensor',
              isRead: 'true',
              interval: '334',
              texttableentry: 'MixerOneCircuitRoomTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitRoomTemperatureSensor',
              isRead: 'true',
              interval: '335',
              texttableentry: 'MixerTwoCircuitRoomTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitRoomTemperatureSensor',
              isRead: 'true',
              interval: '336',
              texttableentry: 'MixerThreeCircuitRoomTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitRoomTemperatureSensor',
              isRead: 'true',
              interval: '337',
              texttableentry: 'MixerFourCircuitRoomTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterOutletSensor',
              isRead: 'true',
              interval: '360',
              texttableentry: 'DomesticHotWaterOutletSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_Flame',
              isRead: 'true',
              interval: '364',
              texttableentry: 'Flame',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FlameStatistical',
              isRead: 'true',
              interval: '365',
              texttableentry: 'FlameStatistical',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FanTargetSpeed',
              isRead: 'true',
              interval: '373',
              texttableentry: 'FanTargetSpeed',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ViessmannIdentificationNumber',
              isRead: 'true',
              interval: '377',
              texttableentry: 'ViessmannIdentificationNumber',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingPump',
              isRead: 'true',
              interval: '381',
              texttableentry: 'CentralHeatingPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_UnitsAndFormats',
              isRead: 'true',
              interval: '382',
              texttableentry: 'UnitsAndFormats',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiverterValveTargetPosition',
              isRead: 'true',
              interval: '386',
              texttableentry: 'DiverterValveTargetPosition',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterPump',
              isRead: 'true',
              interval: '392',
              texttableentry: 'DomesticHotWaterPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTemperatureSetpoint',
              isRead: 'true',
              interval: '396',
              texttableentry: 'DomesticHotWaterTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitPump',
              isRead: 'true',
              interval: '401',
              texttableentry: 'MixerOneCircuitPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitPump',
              isRead: 'true',
              interval: '402',
              texttableentry: 'MixerTwoCircuitPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitPump',
              isRead: 'true',
              interval: '403',
              texttableentry: 'MixerThreeCircuitPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitPump',
              isRead: 'true',
              interval: '404',
              texttableentry: 'MixerFourCircuitPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFiveCircuitPump',
              isRead: 'true',
              interval: '405',
              texttableentry: 'MixerFiveCircuitPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixCircuitPump',
              isRead: 'true',
              interval: '406',
              texttableentry: 'MixerSixCircuitPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSevenCircuitPump',
              isRead: 'true',
              interval: '407',
              texttableentry: 'MixerSevenCircuitPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerEightCircuitPump',
              isRead: 'true',
              interval: '408',
              texttableentry: 'MixerEightCircuitPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarCircuitPump',
              isRead: 'true',
              interval: '417',
              texttableentry: 'SolarCircuitPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '424',
              texttableentry: 'MixerOneCircuitRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '426',
              texttableentry: 'MixerTwoCircuitRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '428',
              texttableentry: 'MixerThreeCircuitRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '430',
              texttableentry: 'MixerFourCircuitRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFiveCircuitRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '432',
              texttableentry: 'MixerFiveCircuitRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixCircuitRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '434',
              texttableentry: 'MixerSixCircuitRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSevenCircuitRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '436',
              texttableentry: 'MixerSevenCircuitRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerEightCircuitRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '438',
              texttableentry: 'MixerEightCircuitRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitThreeWayValvePositionPercent',
              isRead: 'true',
              interval: '475',
              texttableentry: 'MixerOneCircuitThreeWayValvePositionPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitThreeWayValvePositionPercent',
              isRead: 'true',
              interval: '476',
              texttableentry: 'MixerTwoCircuitThreeWayValvePositionPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitThreeWayValvePositionPercent',
              isRead: 'true',
              interval: '477',
              texttableentry: 'MixerThreeCircuitThreeWayValvePositionPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitThreeWayValvePositionPercent',
              isRead: 'true',
              interval: '478',
              texttableentry: 'MixerFourCircuitThreeWayValvePositionPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationPump',
              isRead: 'true',
              interval: '491',
              texttableentry: 'DomesticHotWaterCirculationPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationPumpMode',
              isRead: 'true',
              interval: '497',
              texttableentry: 'DomesticHotWaterCirculationPumpMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatDemandExternalAc',
              isRead: 'true',
              interval: '500',
              texttableentry: 'CentralHeatDemandExternalAc',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ScaldProtection',
              isRead: 'true',
              interval: '503',
              texttableentry: 'ScaldProtection',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterSetpointMetaData',
              isRead: 'true',
              interval: '504',
              texttableentry: 'DomesticHotWaterSetpointMetaData',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_Date',
              isRead: 'true',
              interval: '505',
              texttableentry: 'Date',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_Time',
              isRead: 'true',
              interval: '506',
              texttableentry: 'Time',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_UniversalTimeCoordinated',
              isRead: 'true',
              interval: '507',
              texttableentry: 'UniversalTimeCoordinated',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_UniversalTimeCoordinatedOffset',
              isRead: 'true',
              interval: '508',
              texttableentry: 'UniversalTimeCoordinatedOffset',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_Language',
              isRead: 'true',
              interval: '510',
              texttableentry: 'Language',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayPhaseCircuitOne',
              isRead: 'true',
              interval: '513',
              texttableentry: 'HolidayPhaseCircuitOne',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayAtHomePhaseCircuitOne',
              isRead: 'true',
              interval: '514',
              texttableentry: 'HolidayAtHomePhaseCircuitOne',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayPhaseCircuitTwo',
              isRead: 'true',
              interval: '515',
              texttableentry: 'HolidayPhaseCircuitTwo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayAtHomePhaseCircuitTwo',
              isRead: 'true',
              interval: '516',
              texttableentry: 'HolidayAtHomePhaseCircuitTwo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayPhaseCircuitThree',
              isRead: 'true',
              interval: '517',
              texttableentry: 'HolidayPhaseCircuitThree',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayAtHomePhaseCircuitThree',
              isRead: 'true',
              interval: '518',
              texttableentry: 'HolidayAtHomePhaseCircuitThree',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayPhaseCircuitFour',
              isRead: 'true',
              interval: '519',
              texttableentry: 'HolidayPhaseCircuitFour',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HolidayAtHomePhaseCircuitFour',
              isRead: 'true',
              interval: '520',
              texttableentry: 'HolidayAtHomePhaseCircuitFour',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_OperatingHoursTillService',
              isRead: 'true',
              interval: '521',
              texttableentry: 'OperatingHoursTillService',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ServiceDateNext',
              isRead: 'true',
              interval: '522',
              texttableentry: 'ServiceDateNext',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ModulationTargetSetpoint',
              isRead: 'true',
              interval: '524',
              texttableentry: 'ModulationTargetSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalModulationSetpoint',
              isRead: 'true',
              interval: '525',
              texttableentry: 'ExternalModulationSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ModulationCurrentValue',
              isRead: 'true',
              interval: '526',
              texttableentry: 'ModulationCurrentValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FlowTemperatureTargetSetpoint',
              isRead: 'true',
              interval: '527',
              texttableentry: 'FlowTemperatureTargetSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalTargetFlowTemperatureSetpoint',
              isRead: 'true',
              interval: '528',
              texttableentry: 'ExternalTargetFlowTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTargetOperationState',
              isRead: 'true',
              interval: '531',
              texttableentry: 'DomesticHotWaterOperationState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterPumpPostRunTime',
              isRead: 'true',
              interval: '534',
              texttableentry: 'DomesticHotWaterPumpPostRunTime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ObjectElectricalEnergyStatistical',
              isRead: 'true',
              interval: '535',
              texttableentry: 'ObjectElectricalEnergyStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ExternalMixerOneCircuitTargetOperationMode',
              isRead: 'true',
              interval: '537',
              texttableentry: 'ExternalMixerOneCircuitTargetOperationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalDomesticHotWaterTargetOperationMode',
              isRead: 'true',
              interval: '538',
              texttableentry: 'ExternalDomesticHotWaterTargetOperationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GasConsumptionCentralHeating',
              isRead: 'true',
              interval: '544',
              texttableentry: 'GasConsumptionCentralHeating',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GasConsumptionDomesticHotWater',
              isRead: 'true',
              interval: '545',
              texttableentry: 'GasConsumptionDomesticHotWater',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeating',
              isRead: 'true',
              interval: '548',
              texttableentry: 'EnergyConsumptionCentralHeating',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionDomesticHotWater',
              isRead: 'true',
              interval: '565',
              texttableentry: 'EnergyConsumptionDomesticHotWater',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GeneratedElectricity',
              isRead: 'true',
              interval: '567',
              texttableentry: 'GeneratedElectricity',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CoTwoSavings',
              isRead: 'true',
              interval: '568',
              texttableentry: 'CoTwoSavings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ResetSensorMinMaxAverageStatistics',
              isRead: 'true',
              interval: '569',
              texttableentry: 'ResetSensorMinMaxAverageStatistics',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ResetStatistics',
              isRead: 'true',
              interval: '570',
              texttableentry: 'ResetStatistics',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SetDefaultValues',
              isRead: 'false',
              interval: '571',
              texttableentry: 'SetDefaultValues',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SetDefaultValuesDate',
              isRead: 'true',
              interval: '572',
              texttableentry: 'SetDefaultValuesDate',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RemoteReset',
              isRead: 'true',
              interval: '573',
              texttableentry: 'RemoteReset',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RemoteResetCounter',
              isRead: 'true',
              interval: '574',
              texttableentry: 'RemoteResetCounter',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SetDeliveryStatus',
              isRead: 'false',
              interval: '575',
              texttableentry: 'SetDeliveryStatus',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SetDeliveryStatusDate',
              isRead: 'true',
              interval: '576',
              texttableentry: 'SetDeliveryStatusDate',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeliveryStatusActive',
              isRead: 'true',
              interval: '577',
              texttableentry: 'DeliveryStatusActive',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ProductionInitialisation',
              isRead: 'true',
              interval: '579',
              texttableentry: 'ProductionInitialisation',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SoftwareVersion',
              isRead: 'true',
              interval: '580',
              texttableentry: 'SoftwareVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HardwareVersion',
              isRead: 'true',
              interval: '581',
              texttableentry: 'HardwareVersion',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectronicControlUnitOperationHours',
              isRead: 'true',
              interval: '590',
              texttableentry: 'ElectronicControlUnitOperationHours',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MacAddressLan',
              isRead: 'true',
              interval: '592',
              texttableentry: 'MacAddressLan',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayMac',
              isRead: 'true',
              interval: '593',
              texttableentry: 'GatewayMac',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingPartLoadPercent',
              isRead: 'true',
              interval: '596',
              texttableentry: 'CentralHeatingPartLoadPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterPartLoadPercent',
              isRead: 'true',
              interval: '597',
              texttableentry: 'DomesticHotWaterPartLoadPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellReset',
              isRead: 'true',
              interval: '600',
              texttableentry: 'FuelCellReset',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteLocalNetworkStatus',
              isRead: 'true',
              interval: '602',
              texttableentry: 'GatewayRemoteLocalNetworkStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GatewayApEnable',
              isRead: 'true',
              interval: '603',
              texttableentry: 'GatewayApEnable',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayApDataSet',
              isRead: 'true',
              interval: '604',
              texttableentry: 'GatewayApDataSet',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteIp',
              isRead: 'true',
              interval: '607',
              texttableentry: 'GatewayRemoteIp',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteEnable',
              isRead: 'true',
              interval: '616',
              texttableentry: 'GatewayRemoteEnable',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteSsid',
              isRead: 'false',
              interval: '617',
              texttableentry: 'GatewayRemoteSsid',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteIpStatic',
              isRead: 'true',
              interval: '618',
              texttableentry: 'GatewayRemoteIpStatic',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteScanNetwork',
              isRead: 'true',
              interval: '619',
              texttableentry: 'GatewayRemoteScanNetwork',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ObjectContactDetails',
              isRead: 'true',
              interval: '621',
              texttableentry: 'ObjectContactDetails',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CustomerDetails',
              isRead: 'true',
              interval: '622',
              texttableentry: 'CustomerDetails',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ServiceEngineer',
              isRead: 'true',
              interval: '623',
              texttableentry: 'ServiceEngineer',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_TechnicalSupport',
              isRead: 'true',
              interval: '624',
              texttableentry: 'TechnicalSupport',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ObjectDetails',
              isRead: 'true',
              interval: '625',
              texttableentry: 'ObjectDetails',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingOneCircuitName',
              isRead: 'true',
              interval: '627',
              texttableentry: 'CentralHeatingOneCircuitName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingTwoCircuitName',
              isRead: 'true',
              interval: '628',
              texttableentry: 'CentralHeatingTwoCircuitName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingThreeCircuitName',
              isRead: 'true',
              interval: '629',
              texttableentry: 'CentralHeatingThreeCircuitName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingFourCircuitName',
              isRead: 'true',
              interval: '630',
              texttableentry: 'CentralHeatingFourCircuitName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingFiveCircuitName',
              isRead: 'true',
              interval: '631',
              texttableentry: 'CentralHeatingFiveCircuitName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingSixCircuitName',
              isRead: 'true',
              interval: '632',
              texttableentry: 'CentralHeatingSixCircuitName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingSevenCircuitName',
              isRead: 'true',
              interval: '633',
              texttableentry: 'CentralHeatingSevenCircuitName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingEightCircuitName',
              isRead: 'true',
              interval: '634',
              texttableentry: 'CentralHeatingEightCircuitName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericAnalogDigitalAccessoryOneModulFunction',
              isRead: 'true',
              interval: '645',
              texttableentry: 'GenericAnalogDigitalAccessoryOneModulFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericAnalogDigitalAccessoryTwoModulFunction',
              isRead: 'true',
              interval: '646',
              texttableentry: 'GenericAnalogDigitalAccessoryTwoModulFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericAnalogDigitalAccessoryThreeModulFunction',
              isRead: 'true',
              interval: '647',
              texttableentry: 'GenericAnalogDigitalAccessoryThreeModulFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericAnalogDigitalAccessoryFourModulFunction',
              isRead: 'true',
              interval: '648',
              texttableentry: 'GenericAnalogDigitalAccessoryFourModulFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericAnalogDigitalAccessoryFiveModulFunction',
              isRead: 'true',
              interval: '649',
              texttableentry: 'GenericAnalogDigitalAccessoryFiveModulFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericDigitalAccessoryOneModulFunction',
              isRead: 'true',
              interval: '650',
              texttableentry: 'GenericDigitalAccessoryOneModulFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericDigitalAccessoryTwoModulFunction',
              isRead: 'true',
              interval: '651',
              texttableentry: 'GenericDigitalAccessoryTwoModulFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericDigitalAccessoryThreeModulFunction',
              isRead: 'true',
              interval: '652',
              texttableentry: 'GenericDigitalAccessoryThreeModulFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericDigitalAccessoryFourModulFunction',
              isRead: 'true',
              interval: '653',
              texttableentry: 'GenericDigitalAccessoryFourModulFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericDigitalAccessoryFiveModulFunction',
              isRead: 'true',
              interval: '654',
              texttableentry: 'GenericDigitalAccessoryFiveModulFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericZeroToTenInputConfiguration',
              isRead: 'true',
              interval: '669',
              texttableentry: 'GenericZeroToTenInputConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericMTwoIoAccessoryOneModuleFunction',
              isRead: 'true',
              interval: '676',
              texttableentry: 'GenericMTwoIoAccessoryOneModuleFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTimeScheduleMonday',
              isRead: 'true',
              interval: '691',
              texttableentry: 'DomesticHotWaterTimeScheduleMonday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTimeScheduleTuesday',
              isRead: 'true',
              interval: '692',
              texttableentry: 'DomesticHotWaterTimeScheduleTuesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTimeScheduleWednesday',
              isRead: 'true',
              interval: '693',
              texttableentry: 'DomesticHotWaterTimeScheduleWednesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTimeScheduleThursday',
              isRead: 'true',
              interval: '694',
              texttableentry: 'DomesticHotWaterTimeScheduleThursday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTimeScheduleFriday',
              isRead: 'true',
              interval: '695',
              texttableentry: 'DomesticHotWaterTimeScheduleFriday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTimeScheduleSaturday',
              isRead: 'true',
              interval: '696',
              texttableentry: 'DomesticHotWaterTimeScheduleSaturday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTimeScheduleSunday',
              isRead: 'true',
              interval: '697',
              texttableentry: 'DomesticHotWaterTimeScheduleSunday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationTimeScheduleMonday',
              isRead: 'true',
              interval: '726',
              texttableentry: 'DomesticHotWaterCirculationTimeScheduleMonday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationTimeScheduleTuesday',
              isRead: 'true',
              interval: '727',
              texttableentry: 'DomesticHotWaterCirculationTimeScheduleTuesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationTimeScheduleWednesday',
              isRead: 'true',
              interval: '728',
              texttableentry: 'DomesticHotWaterCirculationTimeScheduleWednesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationTimeScheduleThursday',
              isRead: 'true',
              interval: '729',
              texttableentry: 'DomesticHotWaterCirculationTimeScheduleThursday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationTimeScheduleFriday',
              isRead: 'true',
              interval: '730',
              texttableentry: 'DomesticHotWaterCirculationTimeScheduleFriday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationTimeScheduleSaturday',
              isRead: 'true',
              interval: '731',
              texttableentry: 'DomesticHotWaterCirculationTimeScheduleSaturday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterCirculationTimeScheduleSunday',
              isRead: 'true',
              interval: '732',
              texttableentry: 'DomesticHotWaterCirculationTimeScheduleSunday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitTimeScheduleMonday',
              isRead: 'true',
              interval: '761',
              texttableentry: 'MixerOneCircuitTimeScheduleMonday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitTimeScheduleTuesday',
              isRead: 'true',
              interval: '762',
              texttableentry: 'MixerOneCircuitTimeScheduleTuesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitTimeScheduleWednesday',
              isRead: 'true',
              interval: '763',
              texttableentry: 'MixerOneCircuitTimeScheduleWednesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitTimeScheduleThursday',
              isRead: 'true',
              interval: '764',
              texttableentry: 'MixerOneCircuitTimeScheduleThursday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitTimeScheduleFriday',
              isRead: 'true',
              interval: '765',
              texttableentry: 'MixerOneCircuitTimeScheduleFriday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitTimeScheduleSaturday',
              isRead: 'true',
              interval: '766',
              texttableentry: 'MixerOneCircuitTimeScheduleSaturday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitTimeScheduleSunday',
              isRead: 'true',
              interval: '767',
              texttableentry: 'MixerOneCircuitTimeScheduleSunday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitTimeScheduleMonday',
              isRead: 'true',
              interval: '768',
              texttableentry: 'MixerTwoCircuitTimeScheduleMonday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitTimeScheduleTuesday',
              isRead: 'true',
              interval: '769',
              texttableentry: 'MixerTwoCircuitTimeScheduleTuesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitTimeScheduleWednesday',
              isRead: 'true',
              interval: '770',
              texttableentry: 'MixerTwoCircuitTimeScheduleWednesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitTimeScheduleThursday',
              isRead: 'true',
              interval: '771',
              texttableentry: 'MixerTwoCircuitTimeScheduleThursday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitTimeScheduleFriday',
              isRead: 'true',
              interval: '772',
              texttableentry: 'MixerTwoCircuitTimeScheduleFriday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitTimeScheduleSaturday',
              isRead: 'true',
              interval: '773',
              texttableentry: 'MixerTwoCircuitTimeScheduleSaturday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitTimeScheduleSunday',
              isRead: 'true',
              interval: '774',
              texttableentry: 'MixerTwoCircuitTimeScheduleSunday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitTimeScheduleMonday',
              isRead: 'true',
              interval: '775',
              texttableentry: 'MixerThreeCircuitTimeScheduleMonday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitTimeScheduleTuesday',
              isRead: 'true',
              interval: '776',
              texttableentry: 'MixerThreeCircuitTimeScheduleTuesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitTimeScheduleWednesday',
              isRead: 'true',
              interval: '777',
              texttableentry: 'MixerThreeCircuitTimeScheduleWednesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitTimeScheduleThursday',
              isRead: 'true',
              interval: '778',
              texttableentry: 'MixerThreeCircuitTimeScheduleThursday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitTimeScheduleFriday',
              isRead: 'true',
              interval: '779',
              texttableentry: 'MixerThreeCircuitTimeScheduleFriday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitTimeScheduleSaturday',
              isRead: 'true',
              interval: '780',
              texttableentry: 'MixerThreeCircuitTimeScheduleSaturday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitTimeScheduleSunday',
              isRead: 'true',
              interval: '781',
              texttableentry: 'MixerThreeCircuitTimeScheduleSunday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitTimeScheduleMonday',
              isRead: 'true',
              interval: '782',
              texttableentry: 'MixerFourCircuitTimeScheduleMonday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitTimeScheduleTuesday',
              isRead: 'true',
              interval: '783',
              texttableentry: 'MixerFourCircuitTimeScheduleTuesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitTimeScheduleWednesday',
              isRead: 'true',
              interval: '784',
              texttableentry: 'MixerFourCircuitTimeScheduleWednesday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitTimeScheduleThursday',
              isRead: 'true',
              interval: '785',
              texttableentry: 'MixerFourCircuitTimeScheduleThursday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitTimeScheduleFriday',
              isRead: 'true',
              interval: '786',
              texttableentry: 'MixerFourCircuitTimeScheduleFriday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitTimeScheduleSaturday',
              isRead: 'true',
              interval: '787',
              texttableentry: 'MixerFourCircuitTimeScheduleSaturday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitTimeScheduleSunday',
              isRead: 'true',
              interval: '788',
              texttableentry: 'MixerFourCircuitTimeScheduleSunday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_LegionellaProtectionActivation',
              isRead: 'true',
              interval: '873',
              texttableentry: 'LegionellaProtectionActivation',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_LegionellaProtectionTargetTemperatureSetpoint',
              isRead: 'true',
              interval: '874',
              texttableentry: 'LegionellaProtectionTargetTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_LegionellaProtectionStartTime',
              isRead: 'true',
              interval: '875',
              texttableentry: 'LegionellaProtectionStartTime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_LegionellaProtectionWeekday',
              isRead: 'true',
              interval: '876',
              texttableentry: 'LegionellaProtectionWeekday',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_LegionellaProtectionLastSuccessfulStartTime',
              isRead: 'true',
              interval: '877',
              texttableentry: 'LegionellaProtectionLastSuccessfulStartTime',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_LegionellaProtectionLastSuccessfulWeekday',
              isRead: 'true',
              interval: '878',
              texttableentry: 'LegionellaProtectionLastSuccessfulWeekday',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitCentralHeatingCurve',
              isRead: 'true',
              interval: '880',
              texttableentry: 'MixerOneCircuitCentralHeatingCurve',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitCentralHeatingCurve',
              isRead: 'true',
              interval: '881',
              texttableentry: 'MixerTwoCircuitCentralHeatingCurve',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitCentralHeatingCurve',
              isRead: 'true',
              interval: '882',
              texttableentry: 'MixerThreeCircuitCentralHeatingCurve',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitCentralHeatingCurve',
              isRead: 'true',
              interval: '883',
              texttableentry: 'MixerFourCircuitCentralHeatingCurve',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFiveCircuitCentralHeatingCurve',
              isRead: 'true',
              interval: '884',
              texttableentry: 'MixerFiveCircuitCentralHeatingCurve',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixCircuitCentralHeatingCurve',
              isRead: 'true',
              interval: '885',
              texttableentry: 'MixerSixCircuitCentralHeatingCurve',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSevenCircuitCentralHeatingCurve',
              isRead: 'true',
              interval: '886',
              texttableentry: 'MixerSevenCircuitCentralHeatingCurve',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerEightCircuitCentralHeatingCurve',
              isRead: 'true',
              interval: '887',
              texttableentry: 'MixerEightCircuitCentralHeatingCurve',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_OutsideTemperatureOffset',
              isRead: 'true',
              interval: '896',
              texttableentry: 'OutsideTemperatureOffset',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ScreedDryingProfileActivation',
              isRead: 'true',
              interval: '897',
              texttableentry: 'ScreedDryingProfileActivation',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteSignalStrength',
              isRead: 'true',
              interval: '900',
              texttableentry: 'GatewayRemoteSignalStrength',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ServiceManagerIsRequired',
              isRead: 'true',
              interval: '901',
              texttableentry: 'ServiceManagerIsRequired',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MalfunctionIdentification',
              isRead: 'true',
              interval: '902',
              texttableentry: 'MalfunctionIdentification',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DisplaySettings',
              isRead: 'true',
              interval: '903',
              texttableentry: 'DisplaySettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExhaustFlap',
              isRead: 'true',
              interval: '906',
              texttableentry: 'ExhaustFlap',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalFaultSignal',
              isRead: 'true',
              interval: '908',
              texttableentry: 'ExternalFaultSignal',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DaylightSavingTimeActive',
              isRead: 'true',
              interval: '912',
              texttableentry: 'DaylightSavingTimeActive',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PersistentMemoryLastUpdate',
              isRead: 'true',
              interval: '914',
              texttableentry: 'PersistentMemoryLastUpdate',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_LastBackupDate',
              isRead: 'true',
              interval: '915',
              texttableentry: 'LastBackupDate',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RemoteWeatherService',
              isRead: 'true',
              interval: '917',
              texttableentry: 'RemoteWeatherService',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_TradeFairMode',
              isRead: 'true',
              interval: '918',
              texttableentry: 'TradeFairMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_OutsideTemperatureDampingFactor',
              isRead: 'true',
              interval: '919',
              texttableentry: 'OutsideTemperatureDampingFactor',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ThreeAxisAccelerationSensor',
              isRead: 'true',
              interval: '920',
              texttableentry: 'ThreeAxisAccelerationSensor',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalAccessInProgress',
              isRead: 'true',
              interval: '921',
              texttableentry: 'ExternalAccessInProgress',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ProductionTraceabilityByte',
              isRead: 'true',
              interval: '922',
              texttableentry: 'ProductionTraceabilityByte',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RealTimeClockStatus',
              isRead: 'true',
              interval: '923',
              texttableentry: 'RealTimeClockStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_StartUpWizard',
              isRead: 'true',
              interval: '924',
              texttableentry: 'StartUpWizard',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FillingVenting',
              isRead: 'true',
              interval: '925',
              texttableentry: 'FillingVenting',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BuildingType',
              isRead: 'true',
              interval: '927',
              texttableentry: 'BuildingType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectronicTraceabilityNumber',
              isRead: 'true',
              interval: '928',
              texttableentry: 'ElectronicTraceabilityNumber',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GasType',
              isRead: 'true',
              interval: '929',
              texttableentry: 'GasType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalTargetCentralHeatingFlowSetpointMetaData',
              isRead: 'true',
              interval: '930',
              texttableentry: 'ExternalTargetCentralHeatingFlowSetpointMetaData',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterFlowSetpointMetaData',
              isRead: 'true',
              interval: '931',
              texttableentry: 'DomesticHotWaterFlowSetpointMetaData',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitProperty',
              isRead: 'true',
              interval: '933',
              texttableentry: 'MixerOneCircuitProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitProperty',
              isRead: 'true',
              interval: '934',
              texttableentry: 'MixerTwoCircuitProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitProperty',
              isRead: 'true',
              interval: '935',
              texttableentry: 'MixerThreeCircuitProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitProperty',
              isRead: 'true',
              interval: '936',
              texttableentry: 'MixerFourCircuitProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFiveCircuitProperty',
              isRead: 'true',
              interval: '937',
              texttableentry: 'MixerFiveCircuitProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixCircuitProperty',
              isRead: 'true',
              interval: '938',
              texttableentry: 'MixerSixCircuitProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSevenCircuitProperty',
              isRead: 'true',
              interval: '939',
              texttableentry: 'MixerSevenCircuitProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerEightCircuitProperty',
              isRead: 'true',
              interval: '940',
              texttableentry: 'MixerEightCircuitProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarCircuitWaterFlowRate',
              isRead: 'true',
              interval: '950',
              texttableentry: 'SolarCircuitWaterFlowRate',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarCircuitExtendedFunctions',
              isRead: 'true',
              interval: '951',
              texttableentry: 'SolarCircuitExtendedFunctions',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HydraulicMatrix',
              isRead: 'true',
              interval: '952',
              texttableentry: 'HydraulicMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarEnergyYield',
              isRead: 'true',
              interval: '953',
              texttableentry: 'SolarEnergyYield',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrix',
              isRead: 'true',
              interval: '954',
              texttableentry: 'BusTopologyMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ExhaustPipeType',
              isRead: 'true',
              interval: '960',
              texttableentry: 'ExhaustPipeType',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SecurityAlgorithmNumber',
              isRead: 'true',
              interval: '961',
              texttableentry: 'SecurityAlgorithmNumber',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BootLoaderVersion',
              isRead: 'true',
              interval: '962',
              texttableentry: 'BootLoaderVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ActiveDiagnosticSession',
              isRead: 'true',
              interval: '964',
              texttableentry: 'ActiveDiagnosticSession',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitFlowTemperatureTargetSetpoint',
              isRead: 'true',
              interval: '987',
              texttableentry: 'MixerOneCircuitFlowTemperatureTargetSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitFlowTemperatureTargetSetpoint',
              isRead: 'true',
              interval: '988',
              texttableentry: 'MixerTwoCircuitFlowTemperatureTargetSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitFlowTemperatureTargetSetpoint',
              isRead: 'true',
              interval: '989',
              texttableentry: 'MixerThreeCircuitFlowTemperatureTargetSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitFlowTemperatureTargetSetpoint',
              isRead: 'true',
              interval: '990',
              texttableentry: 'MixerFourCircuitFlowTemperatureTargetSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFiveCircuitFlowTemperatureTargetSetpoint',
              isRead: 'true',
              interval: '991',
              texttableentry: 'MixerFiveCircuitFlowTemperatureTargetSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixCircuitFlowTemperatureTargetSetpoint',
              isRead: 'true',
              interval: '992',
              texttableentry: 'MixerSixCircuitFlowTemperatureTargetSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSevenCircuitFlowTemperatureTargetSetpoint',
              isRead: 'true',
              interval: '993',
              texttableentry: 'MixerSevenCircuitFlowTemperatureTargetSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerEightCircuitFlowTemperatureTargetSetpoint',
              isRead: 'true',
              interval: '994',
              texttableentry: 'MixerEightCircuitFlowTemperatureTargetSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingRegulationMode',
              isRead: 'true',
              interval: '1004',
              texttableentry: 'CentralHeatingRegulationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_TargetQuickMode',
              isRead: 'true',
              interval: '1006',
              texttableentry: 'TargetQuickMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CurrentQuickMode',
              isRead: 'true',
              interval: '1007',
              texttableentry: 'CurrentQuickMode',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitTargetQuickMode',
              isRead: 'true',
              interval: '1008',
              texttableentry: 'MixerOneCircuitTargetQuickMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitTargetQuickMode',
              isRead: 'true',
              interval: '1009',
              texttableentry: 'MixerTwoCircuitTargetQuickMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitTargetQuickMode',
              isRead: 'true',
              interval: '1010',
              texttableentry: 'MixerThreeCircuitTargetQuickMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitTargetQuickMode',
              isRead: 'true',
              interval: '1011',
              texttableentry: 'MixerFourCircuitTargetQuickMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitCurrentQuickMode',
              isRead: 'true',
              interval: '1024',
              texttableentry: 'MixerOneCircuitCurrentQuickMode',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitCurrentQuickMode',
              isRead: 'true',
              interval: '1025',
              texttableentry: 'MixerTwoCircuitCurrentQuickMode',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitCurrentQuickMode',
              isRead: 'true',
              interval: '1026',
              texttableentry: 'MixerThreeCircuitCurrentQuickMode',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitCurrentQuickMode',
              isRead: 'true',
              interval: '1027',
              texttableentry: 'MixerFourCircuitCurrentQuickMode',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PrimaryHeatExchangerTemperatureSensor',
              isRead: 'true',
              interval: '1042',
              texttableentry: 'PrimaryHeatExchangerTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_AllengraSensor',
              isRead: 'true',
              interval: '1043',
              texttableentry: 'AllengraSensor',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SecondaryCentralHeatingPump',
              isRead: 'true',
              interval: '1044',
              texttableentry: 'SecondaryCentralHeatingPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedFlowTemperatureSensor',
              isRead: 'true',
              interval: '1047',
              texttableentry: 'TimeSeriesRecordedFlowTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FreezeFrame',
              isRead: 'true',
              interval: '1081',
              texttableentry: 'FreezeFrame',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingPumpPostRuntime',
              isRead: 'true',
              interval: '1083',
              texttableentry: 'CentralHeatingPumpPostRuntime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FlowTemperatureMinimumMaximumLimit',
              isRead: 'true',
              interval: '1084',
              texttableentry: 'FlowTemperatureMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterHysteresis',
              isRead: 'true',
              interval: '1085',
              texttableentry: 'DomesticHotWaterHysteresis',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MaximumDomesticHotWaterLoadingTime',
              isRead: 'true',
              interval: '1087',
              texttableentry: 'MaximumDomesticHotWaterLoadingTime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ResetEnergyManagerDataCollector',
              isRead: 'true',
              interval: '1096',
              texttableentry: 'ResetEnergyManagerDataCollector',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricityPrice',
              isRead: 'true',
              interval: '1097',
              texttableentry: 'ElectricityPrice',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GasProperties',
              isRead: 'true',
              interval: '1098',
              texttableentry: 'GasProperties',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingPumpMinimumMaximumLimit',
              isRead: 'true',
              interval: '1100',
              texttableentry: 'CentralHeatingPumpMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterPumpMinimumMaximumLimit',
              isRead: 'true',
              interval: '1101',
              texttableentry: 'DomesticHotWaterPumpMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitPumpMinimumMaximumLimit',
              isRead: 'true',
              interval: '1102',
              texttableentry: 'MixerOneCircuitPumpMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitPumpMinimumMaximumLimit',
              isRead: 'true',
              interval: '1103',
              texttableentry: 'MixerTwoCircuitPumpMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitPumpMinimumMaximumLimit',
              isRead: 'true',
              interval: '1104',
              texttableentry: 'MixerThreeCircuitPumpMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitPumpMinimumMaximumLimit',
              isRead: 'true',
              interval: '1105',
              texttableentry: 'MixerFourCircuitPumpMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarCircuitPumpMinimumMaximumLimit',
              isRead: 'true',
              interval: '1118',
              texttableentry: 'SolarCircuitPumpMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarMaximumLoadingTemperature',
              isRead: 'true',
              interval: '1125',
              texttableentry: 'SolarMaximumLoadingTemperature',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarMinimumMaximumCollectorTemperature',
              isRead: 'true',
              interval: '1126',
              texttableentry: 'SolarMinimumMaximumCollectorTemperature',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarCollectorFrostprotection',
              isRead: 'true',
              interval: '1127',
              texttableentry: 'SolarCollectorFrostprotection',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarStagnationHours',
              isRead: 'true',
              interval: '1128',
              texttableentry: 'SolarStagnationHours',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarAlternatelyCharge',
              isRead: 'true',
              interval: '1129',
              texttableentry: 'SolarAlternatelyCharge',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ParameterIdentificationVersion',
              isRead: 'true',
              interval: '1131',
              texttableentry: 'ParameterIdentificationVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SolarProperty',
              isRead: 'true',
              interval: '1136',
              texttableentry: 'SolarProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AccentLedBar',
              isRead: 'true',
              interval: '1138',
              texttableentry: 'AccentLedBar',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingCurveAdaptionParameter',
              isRead: 'true',
              interval: '1139',
              texttableentry: 'CentralHeatingCurveAdaptionParameter',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BackendConnectionStatus',
              isRead: 'true',
              interval: '1165',
              texttableentry: 'BackendConnectionStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ResetDtcHistory',
              isRead: 'true',
              interval: '1166',
              texttableentry: 'ResetDtcHistory',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalDomesticHotWaterTemperatureSetpoint',
              isRead: 'true',
              interval: '1167',
              texttableentry: 'ExternalDomesticHotWaterTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterRegulationMode',
              isRead: 'true',
              interval: '1171',
              texttableentry: 'DomesticHotWaterRegulationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarCircuitPumpStatistical',
              isRead: 'true',
              interval: '1172',
              texttableentry: 'SolarCircuitPumpStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_AcknowledgeInfoAlarmMessage',
              isRead: 'true',
              interval: '1175',
              texttableentry: 'AcknowledgeInfoAlarmMessage',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AcknowledgeWarningAlarmMessage',
              isRead: 'true',
              interval: '1176',
              texttableentry: 'AcknowledgeWarningAlarmMessage',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AcknowledgeServiceAlarmMessage',
              isRead: 'true',
              interval: '1177',
              texttableentry: 'AcknowledgeServiceAlarmMessage',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AcknowledgeErrorAlarmMessage',
              isRead: 'true',
              interval: '1178',
              texttableentry: 'AcknowledgeErrorAlarmMessage',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ThermalPower',
              isRead: 'true',
              interval: '1190',
              texttableentry: 'ThermalPower',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellStatus',
              isRead: 'true',
              interval: '1191',
              texttableentry: 'FuelCellStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitFlowTemperatureMinimumMaximumLimit',
              isRead: 'true',
              interval: '1192',
              texttableentry: 'MixerOneCircuitFlowTemperatureMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitFlowTemperatureMinimumMaximumLimit',
              isRead: 'true',
              interval: '1193',
              texttableentry: 'MixerTwoCircuitFlowTemperatureMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitFlowTemperatureMinimumMaximumLimit',
              isRead: 'true',
              interval: '1194',
              texttableentry: 'MixerThreeCircuitFlowTemperatureMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitFlowTemperatureMinimumMaximumLimit',
              isRead: 'true',
              interval: '1195',
              texttableentry: 'MixerFourCircuitFlowTemperatureMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFiveCircuitFlowTemperatureMinimumMaximumLimit',
              isRead: 'true',
              interval: '1196',
              texttableentry: 'MixerFiveCircuitFlowTemperatureMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixCircuitFlowTemperatureMinimumMaximumLimit',
              isRead: 'true',
              interval: '1197',
              texttableentry: 'MixerSixCircuitFlowTemperatureMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSevenCircuitFlowTemperatureMinimumMaximumLimit',
              isRead: 'true',
              interval: '1198',
              texttableentry: 'MixerSevenCircuitFlowTemperatureMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerEightCircuitFlowTemperatureMinimumMaximumLimit',
              isRead: 'true',
              interval: '1199',
              texttableentry: 'MixerEightCircuitFlowTemperatureMinimumMaximumLimit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellStatistical',
              isRead: 'true',
              interval: '1210',
              texttableentry: 'FuelCellStatistical',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GeneratedCentralHeatingOutput',
              isRead: 'true',
              interval: '1211',
              texttableentry: 'GeneratedCentralHeatingOutput',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalPowerOutput',
              isRead: 'true',
              interval: '1214',
              texttableentry: 'ElectricalPowerOutput',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellState',
              isRead: 'true',
              interval: '1215',
              texttableentry: 'FuelCellState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellStateTwo',
              isRead: 'true',
              interval: '1216',
              texttableentry: 'FuelCellStateTwo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellGenerationMode',
              isRead: 'true',
              interval: '1217',
              texttableentry: 'FuelCellGenerationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellInstruction',
              isRead: 'true',
              interval: '1218',
              texttableentry: 'FuelCellInstruction',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellMode',
              isRead: 'true',
              interval: '1220',
              texttableentry: 'FuelCellMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellModeResult',
              isRead: 'true',
              interval: '1221',
              texttableentry: 'FuelCellModeResult',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellRunRequest',
              isRead: 'true',
              interval: '1222',
              texttableentry: 'FuelCellRunRequest',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellRunRequestResult',
              isRead: 'true',
              interval: '1223',
              texttableentry: 'FuelCellRunRequestResult',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellStopRequest',
              isRead: 'true',
              interval: '1224',
              texttableentry: 'FuelCellStopRequest',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellStopRequestResult',
              isRead: 'true',
              interval: '1225',
              texttableentry: 'FuelCellStopRequestResult',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellProcessNumber',
              isRead: 'true',
              interval: '1226',
              texttableentry: 'FuelCellProcessNumber',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellRequestAction',
              isRead: 'true',
              interval: '1227',
              texttableentry: 'FuelCellRequestAction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellCompletionNotification',
              isRead: 'true',
              interval: '1228',
              texttableentry: 'FuelCellCompletionNotification',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellGasTypeSetting',
              isRead: 'true',
              interval: '1229',
              texttableentry: 'FuelCellGasTypeSetting',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellCountrySetting',
              isRead: 'true',
              interval: '1230',
              texttableentry: 'FuelCellCountrySetting',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellPrimaryPump',
              isRead: 'true',
              interval: '1231',
              texttableentry: 'FuelCellPrimaryPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericDigitalInputConfigurationOnBoardOne',
              isRead: 'true',
              interval: '1232',
              texttableentry: 'GenericDigitalInputConfigurationOnBoardOne',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteVisibleOneTwo',
              isRead: 'true',
              interval: '1233',
              texttableentry: 'GatewayRemoteVisibleOneTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteVisibleThreeFour',
              isRead: 'true',
              interval: '1234',
              texttableentry: 'GatewayRemoteVisibleThreeFour',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteVisibleFiveSix',
              isRead: 'true',
              interval: '1235',
              texttableentry: 'GatewayRemoteVisibleFiveSix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteVisibleSevenEight',
              isRead: 'true',
              interval: '1236',
              texttableentry: 'GatewayRemoteVisibleSevenEight',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteVisibleNineTen',
              isRead: 'true',
              interval: '1237',
              texttableentry: 'GatewayRemoteVisibleNineTen',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_AvailableActorSensorComponents',
              isRead: 'true',
              interval: '1238',
              texttableentry: 'AvailableActorSensorComponents',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ActorSensorTest',
              isRead: 'true',
              interval: '1239',
              texttableentry: 'ActorSensorTest',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingPumpMode',
              isRead: 'true',
              interval: '1240',
              texttableentry: 'CentralHeatingPumpMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiverterValveBoilerHydraulicTower',
              isRead: 'true',
              interval: '1263',
              texttableentry: 'DiverterValveBoilerHydraulicTower',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiverterValveFuelCellHydraulicTower',
              isRead: 'true',
              interval: '1264',
              texttableentry: 'DiverterValveFuelCellHydraulicTower',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FanTargetSpeedMeta',
              isRead: 'true',
              interval: '1265',
              texttableentry: 'FanTargetSpeedMeta',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiverterValveStatistical',
              isRead: 'true',
              interval: '1266',
              texttableentry: 'DiverterValveStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HeatEnginePerformanceParameter',
              isRead: 'true',
              interval: '1283',
              texttableentry: 'HeatEnginePerformanceParameter',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrixTwo',
              isRead: 'true',
              interval: '1286',
              texttableentry: 'BusTopologyMatrixTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrixThree',
              isRead: 'true',
              interval: '1287',
              texttableentry: 'BusTopologyMatrixThree',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrixFour',
              isRead: 'true',
              interval: '1288',
              texttableentry: 'BusTopologyMatrixFour',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrixFive',
              isRead: 'true',
              interval: '1289',
              texttableentry: 'BusTopologyMatrixFive',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterShiftLoadPump',
              isRead: 'true',
              interval: '1290',
              texttableentry: 'DomesticHotWaterShiftLoadPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingMonthMatrix',
              isRead: 'true',
              interval: '1294',
              texttableentry: 'EnergyConsumptionCentralHeatingMonthMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionDomesticHotWaterMonthMatrix',
              isRead: 'true',
              interval: '1311',
              texttableentry: 'EnergyConsumptionDomesticHotWaterMonthMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GeneratedElectricityMonthMatrix',
              isRead: 'true',
              interval: '1313',
              texttableentry: 'GeneratedElectricityMonthMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarEnergyYieldMonthMatrix',
              isRead: 'true',
              interval: '1314',
              texttableentry: 'SolarEnergyYieldMonthMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GeneratedCentralHeatingOutputMonthMatrix',
              isRead: 'true',
              interval: '1315',
              texttableentry: 'GeneratedCentralHeatingOutputMonthMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionCentralHeatingYearMatrix',
              isRead: 'true',
              interval: '1316',
              texttableentry: 'EnergyConsumptionCentralHeatingYearMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EnergyConsumptionDomesticHotWaterYearMatrix',
              isRead: 'true',
              interval: '1333',
              texttableentry: 'EnergyConsumptionDomesticHotWaterYearMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GeneratedElectricityYearMatrix',
              isRead: 'true',
              interval: '1335',
              texttableentry: 'GeneratedElectricityYearMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarEnergyYieldYearMatrix',
              isRead: 'true',
              interval: '1336',
              texttableentry: 'SolarEnergyYieldYearMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GeneratedCentralHeatingOutputYearMatrix',
              isRead: 'true',
              interval: '1337',
              texttableentry: 'GeneratedCentralHeatingOutputYearMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MalfunctionHeatingUnitBlocked',
              isRead: 'true',
              interval: '1339',
              texttableentry: 'MalfunctionHeatingUnitBlocked',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellGeneratedHeatOutputMonthMatrix',
              isRead: 'true',
              interval: '1340',
              texttableentry: 'FuelCellGeneratedHeatOutputMonthMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellGeneratedHeatOutputYearMatrix',
              isRead: 'true',
              interval: '1341',
              texttableentry: 'FuelCellGeneratedHeatOutputYearMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GasConsumptionCentralHeatingMonthMatrix',
              isRead: 'true',
              interval: '1342',
              texttableentry: 'GasConsumptionCentralHeatingMonthMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GasConsumptionCentralHeatingYearMatrix',
              isRead: 'true',
              interval: '1343',
              texttableentry: 'GasConsumptionCentralHeatingYearMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GasConsumptionDomesticHotWaterMonthMatrix',
              isRead: 'true',
              interval: '1344',
              texttableentry: 'GasConsumptionDomesticHotWaterMonthMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GasConsumptionDomesticHotWaterYearMatrix',
              isRead: 'true',
              interval: '1345',
              texttableentry: 'GasConsumptionDomesticHotWaterYearMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HeatEngineStatistical',
              isRead: 'true',
              interval: '1346',
              texttableentry: 'HeatEngineStatistical',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ObjectElectricalEnergyStatus',
              isRead: 'true',
              interval: '1347',
              texttableentry: 'ObjectElectricalEnergyStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellGasConsumption',
              isRead: 'true',
              interval: '1348',
              texttableentry: 'FuelCellGasConsumption',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellGasConsumptionMonthMatrix',
              isRead: 'true',
              interval: '1349',
              texttableentry: 'FuelCellGasConsumptionMonthMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellGasConsumptionYearMatrix',
              isRead: 'true',
              interval: '1350',
              texttableentry: 'FuelCellGasConsumptionYearMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FeedInEnergy',
              isRead: 'true',
              interval: '1351',
              texttableentry: 'FeedInEnergy',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FeedInEnergyMonthMatrix',
              isRead: 'true',
              interval: '1352',
              texttableentry: 'FeedInEnergyMonthMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FeedInEnergyYearMatrix',
              isRead: 'true',
              interval: '1353',
              texttableentry: 'FeedInEnergyYearMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ProductionCoverageRate',
              isRead: 'true',
              interval: '1354',
              texttableentry: 'ProductionCoverageRate',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ProductionCoverageRateMonthMatrix',
              isRead: 'true',
              interval: '1355',
              texttableentry: 'ProductionCoverageRateMonthMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ProductionCoverageRateYearMatrix',
              isRead: 'true',
              interval: '1356',
              texttableentry: 'ProductionCoverageRateYearMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellOperationTime',
              isRead: 'true',
              interval: '1357',
              texttableentry: 'FuelCellOperationTime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellOperationTimeMonthMatrix',
              isRead: 'true',
              interval: '1358',
              texttableentry: 'FuelCellOperationTimeMonthMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellOperationTimeYearMatrix',
              isRead: 'true',
              interval: '1359',
              texttableentry: 'FuelCellOperationTimeYearMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellRunTime',
              isRead: 'true',
              interval: '1360',
              texttableentry: 'FuelCellRunTime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellRunTimeMonthMatrix',
              isRead: 'true',
              interval: '1361',
              texttableentry: 'FuelCellRunTimeMonthMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellRunTimeYearMatrix',
              isRead: 'true',
              interval: '1362',
              texttableentry: 'FuelCellRunTimeYearMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellTargetOperationMode',
              isRead: 'true',
              interval: '1363',
              texttableentry: 'FuelCellTargetOperationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericSdioAccessoryOneModulFunction',
              isRead: 'true',
              interval: '1364',
              texttableentry: 'GenericSdioAccessoryOneModulFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellThermalPower',
              isRead: 'true',
              interval: '1367',
              texttableentry: 'FuelCellThermalPower',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DemandCoverageRate',
              isRead: 'true',
              interval: '1371',
              texttableentry: 'DemandCoverageRate',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DemandCoverageRateMonthMatrix',
              isRead: 'true',
              interval: '1372',
              texttableentry: 'DemandCoverageRateMonthMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DemandCoverageRateYearMatrix',
              isRead: 'true',
              interval: '1373',
              texttableentry: 'DemandCoverageRateYearMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_TroubleFreeRate',
              isRead: 'true',
              interval: '1374',
              texttableentry: 'TroubleFreeRate',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TroubleFreeRateMonthMatrix',
              isRead: 'true',
              interval: '1375',
              texttableentry: 'TroubleFreeRateMonthMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TroubleFreeRateYearMatrix',
              isRead: 'true',
              interval: '1376',
              texttableentry: 'TroubleFreeRateYearMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellTroubleFreeRate',
              isRead: 'true',
              interval: '1377',
              texttableentry: 'FuelCellTroubleFreeRate',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellTroubleFreeRateMonthMatrix',
              isRead: 'true',
              interval: '1378',
              texttableentry: 'FuelCellTroubleFreeRateMonthMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellTroubleFreeRateYearMatrix',
              isRead: 'true',
              interval: '1379',
              texttableentry: 'FuelCellTroubleFreeRateYearMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellBreakdownRate',
              isRead: 'true',
              interval: '1383',
              texttableentry: 'FuelCellBreakdownRate',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellBreakdownRateMonthMatrix',
              isRead: 'true',
              interval: '1384',
              texttableentry: 'FuelCellBreakdownRateMonthMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellBreakdownRateYearMatrix',
              isRead: 'true',
              interval: '1385',
              texttableentry: 'FuelCellBreakdownRateYearMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CoTwoSavingsMonthMatrix',
              isRead: 'true',
              interval: '1389',
              texttableentry: 'CoTwoSavingsMonthMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CoTwoSavingsYearMatrix',
              isRead: 'true',
              interval: '1390',
              texttableentry: 'CoTwoSavingsYearMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GeneratedDomesticHotWaterOutput',
              isRead: 'true',
              interval: '1391',
              texttableentry: 'GeneratedDomesticHotWaterOutput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GeneratedDomesticHotWaterOutputMonthMatrix',
              isRead: 'true',
              interval: '1392',
              texttableentry: 'GeneratedDomesticHotWaterOutputMonthMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GeneratedDomesticHotWaterOutputYearMatrix',
              isRead: 'true',
              interval: '1393',
              texttableentry: 'GeneratedDomesticHotWaterOutputYearMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarChargingDomesticHotWaterSetpoint',
              isRead: 'true',
              interval: '1394',
              texttableentry: 'SolarChargingDomesticHotWaterSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitSummerSavingTemperatureThreshold',
              isRead: 'true',
              interval: '1395',
              texttableentry: 'MixerOneCircuitSummerSavingTemperatureThreshold',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitSummerSavingTemperatureThreshold',
              isRead: 'true',
              interval: '1396',
              texttableentry: 'MixerTwoCircuitSummerSavingTemperatureThreshold',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitSummerSavingTemperatureThreshold',
              isRead: 'true',
              interval: '1397',
              texttableentry: 'MixerThreeCircuitSummerSavingTemperatureThreshold',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitSummerSavingTemperatureThreshold',
              isRead: 'true',
              interval: '1398',
              texttableentry: 'MixerFourCircuitSummerSavingTemperatureThreshold',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ResetServiceInterval',
              isRead: 'true',
              interval: '1411',
              texttableentry: 'ResetServiceInterval',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitOperationState',
              isRead: 'true',
              interval: '1415',
              texttableentry: 'MixerOneCircuitOperationState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitOperationState',
              isRead: 'true',
              interval: '1416',
              texttableentry: 'MixerTwoCircuitOperationState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitOperationState',
              isRead: 'true',
              interval: '1417',
              texttableentry: 'MixerThreeCircuitOperationState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitOperationState',
              isRead: 'true',
              interval: '1418',
              texttableentry: 'MixerFourCircuitOperationState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFiveCircuitOperationState',
              isRead: 'true',
              interval: '1419',
              texttableentry: 'MixerFiveCircuitOperationState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixCircuitOperationState',
              isRead: 'true',
              interval: '1420',
              texttableentry: 'MixerSixCircuitOperationState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSevenCircuitOperationState',
              isRead: 'true',
              interval: '1421',
              texttableentry: 'MixerSevenCircuitOperationState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerEightCircuitOperationState',
              isRead: 'true',
              interval: '1422',
              texttableentry: 'MixerEightCircuitOperationState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CarbonEmissionSettings',
              isRead: 'true',
              interval: '1431',
              texttableentry: 'CarbonEmissionSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingPumpPerformance',
              isRead: 'true',
              interval: '1432',
              texttableentry: 'CentralHeatingPumpPerformance',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ResetFuelCellStatistics',
              isRead: 'true',
              interval: '1434',
              texttableentry: 'ResetFuelCellStatistics',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellFlowTemperatureSensor',
              isRead: 'true',
              interval: '1435',
              texttableentry: 'FuelCellFlowTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellReturnTemperatureSensor',
              isRead: 'true',
              interval: '1436',
              texttableentry: 'FuelCellReturnTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ApplicationChecksum',
              isRead: 'true',
              interval: '1451',
              texttableentry: 'ApplicationChecksum',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalInputOneValue',
              isRead: 'true',
              interval: '1452',
              texttableentry: 'DeviceDigitalInputOneValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalInputTwoValue',
              isRead: 'true',
              interval: '1453',
              texttableentry: 'DeviceDigitalInputTwoValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalInputThreeValue',
              isRead: 'true',
              interval: '1454',
              texttableentry: 'DeviceDigitalInputThreeValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalInputFourValue',
              isRead: 'true',
              interval: '1455',
              texttableentry: 'DeviceDigitalInputFourValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputOneValue',
              isRead: 'true',
              interval: '1456',
              texttableentry: 'DeviceDigitalOutputOneValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputTwoValue',
              isRead: 'true',
              interval: '1457',
              texttableentry: 'DeviceDigitalOutputTwoValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputThreeValue',
              isRead: 'true',
              interval: '1458',
              texttableentry: 'DeviceDigitalOutputThreeValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputFourValue',
              isRead: 'true',
              interval: '1459',
              texttableentry: 'DeviceDigitalOutputFourValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputFiveValue',
              isRead: 'true',
              interval: '1460',
              texttableentry: 'DeviceDigitalOutputFiveValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputSixValue',
              isRead: 'true',
              interval: '1461',
              texttableentry: 'DeviceDigitalOutputSixValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DevicePwmOutputOneValue',
              isRead: 'true',
              interval: '1462',
              texttableentry: 'DevicePwmOutputOneValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DevicePwmOutputTwoValue',
              isRead: 'true',
              interval: '1463',
              texttableentry: 'DevicePwmOutputTwoValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AnalogInputZeroToTenOneValue',
              isRead: 'true',
              interval: '1464',
              texttableentry: 'AnalogInputZeroToTenOneValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AnalogOutputZeroToTenOneValue',
              isRead: 'true',
              interval: '1465',
              texttableentry: 'AnalogOutputZeroToTenOneValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AnalogAdcInputValues',
              isRead: 'true',
              interval: '1466',
              texttableentry: 'AnalogAdcInputValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SafetyRelevantRemoteUnlock',
              isRead: 'true',
              interval: '1467',
              texttableentry: 'SafetyRelevantRemoteUnlock',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellGasPressure',
              isRead: 'true',
              interval: '1468',
              texttableentry: 'FuelCellGasPressure',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SensorActuatorTestGroupHeatEngine',
              isRead: 'true',
              interval: '1469',
              texttableentry: 'SensorActuatorTestGroupHeatEngine',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SensorActuatorTestGroupDomesticHotWater',
              isRead: 'true',
              interval: '1470',
              texttableentry: 'SensorActuatorTestGroupDomesticHotWater',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SensorActuatorTestGroupFuelCell',
              isRead: 'true',
              interval: '1471',
              texttableentry: 'SensorActuatorTestGroupFuelCell',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SensorActuatorTestGroupHeatingCircuit',
              isRead: 'true',
              interval: '1472',
              texttableentry: 'SensorActuatorTestGroupHeatingCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SensorActuatorTestGroupSolar',
              isRead: 'true',
              interval: '1473',
              texttableentry: 'SensorActuatorTestGroupSolar',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SolarCircuitPumpHysteresis',
              isRead: 'true',
              interval: '1492',
              texttableentry: 'SolarCircuitPumpHysteresis',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HeatEnginePerformanceStatistics',
              isRead: 'true',
              interval: '1493',
              texttableentry: 'HeatEnginePerformanceStatistics',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_OemProductVersion',
              isRead: 'true',
              interval: '1494',
              texttableentry: 'OemProductVersion',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_StepperMotorOutputOne',
              isRead: 'true',
              interval: '1495',
              texttableentry: 'StepperMotorOutputOne',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_StepperMotorOutputTwo',
              isRead: 'true',
              interval: '1496',
              texttableentry: 'StepperMotorOutputTwo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceAnalogInputOneValue',
              isRead: 'true',
              interval: '1497',
              texttableentry: 'DeviceAnalogInputOneValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceAnalogInputTwoValue',
              isRead: 'true',
              interval: '1498',
              texttableentry: 'DeviceAnalogInputTwoValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceAnalogInputThreeValue',
              isRead: 'true',
              interval: '1499',
              texttableentry: 'DeviceAnalogInputThreeValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceAnalogInputFourValue',
              isRead: 'true',
              interval: '1500',
              texttableentry: 'DeviceAnalogInputFourValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceAnalogInputFiveValue',
              isRead: 'true',
              interval: '1501',
              texttableentry: 'DeviceAnalogInputFiveValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MinimumLoadKw',
              isRead: 'true',
              interval: '1502',
              texttableentry: 'MinimumLoadKw',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MinimumLoadPercent',
              isRead: 'true',
              interval: '1503',
              texttableentry: 'MinimumLoadPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_TimeSettingSource',
              isRead: 'true',
              interval: '1504',
              texttableentry: 'TimeSettingSource',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarStagnationTemperatureOffset',
              isRead: 'true',
              interval: '1505',
              texttableentry: 'SolarStagnationTemperatureOffset',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AccessoryValveOneTargetPositionPercent',
              isRead: 'true',
              interval: '1506',
              texttableentry: 'AccessoryValveOneTargetPositionPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AccessoryValveOneCurrentPositionPercent',
              isRead: 'true',
              interval: '1507',
              texttableentry: 'AccessoryValveOneCurrentPositionPercent',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_AccessoryValveOneMinMaxLimit',
              isRead: 'true',
              interval: '1508',
              texttableentry: 'AccessoryValveOneMinMaxLimit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_AccessoryValveTwoTargetPositionPercent',
              isRead: 'true',
              interval: '1509',
              texttableentry: 'AccessoryValveTwoTargetPositionPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AccessoryValveTwoCurrentPositionPercent',
              isRead: 'true',
              interval: '1510',
              texttableentry: 'AccessoryValveTwoCurrentPositionPercent',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_AccessoryValveTwoMinMaxLimit',
              isRead: 'true',
              interval: '1511',
              texttableentry: 'AccessoryValveTwoMinMaxLimit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_AccessoryPumpOneValue',
              isRead: 'true',
              interval: '1512',
              texttableentry: 'AccessoryPumpOneValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AccessoryPumpTwoValue',
              isRead: 'true',
              interval: '1513',
              texttableentry: 'AccessoryPumpTwoValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AccessoryPumpThreeValue',
              isRead: 'true',
              interval: '1514',
              texttableentry: 'AccessoryPumpThreeValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AccessoryPumpFourValue',
              isRead: 'true',
              interval: '1515',
              texttableentry: 'AccessoryPumpFourValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AccessoryPumpFiveValue',
              isRead: 'true',
              interval: '1516',
              texttableentry: 'AccessoryPumpFiveValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AccessoryPumpSixValue',
              isRead: 'true',
              interval: '1517',
              texttableentry: 'AccessoryPumpSixValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AccessoryPumpOneStatistical',
              isRead: 'true',
              interval: '1518',
              texttableentry: 'AccessoryPumpOneStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_AccessoryPumpTwoStatistical',
              isRead: 'true',
              interval: '1519',
              texttableentry: 'AccessoryPumpTwoStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_AccessoryPumpThreeStatistical',
              isRead: 'true',
              interval: '1520',
              texttableentry: 'AccessoryPumpThreeStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_AccessoryPumpFourStatistical',
              isRead: 'true',
              interval: '1521',
              texttableentry: 'AccessoryPumpFourStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_AccessoryPumpFiveStatistical',
              isRead: 'true',
              interval: '1522',
              texttableentry: 'AccessoryPumpFiveStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_AccessoryPumpSixStatistical',
              isRead: 'true',
              interval: '1523',
              texttableentry: 'AccessoryPumpSixStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_AccessoryNextErrorDtc',
              isRead: 'true',
              interval: '1526',
              texttableentry: 'AccessoryNextErrorDtc',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_LastResetCause',
              isRead: 'true',
              interval: '1527',
              texttableentry: 'LastResetCause',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AccessoryStartupComplete',
              isRead: 'true',
              interval: '1528',
              texttableentry: 'AccessoryStartupComplete',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SolarRechargeSuppressionImpact',
              isRead: 'true',
              interval: '1529',
              texttableentry: 'SolarRechargeSuppressionImpact',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PlusBusAuthentication',
              isRead: 'true',
              interval: '1532',
              texttableentry: 'PlusBusAuthentication',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_InstallationWizardInProgress',
              isRead: 'true',
              interval: '1533',
              texttableentry: 'InstallationWizardInProgress',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceAnalogInputTwoFunctionSelector',
              isRead: 'true',
              interval: '1534',
              texttableentry: 'DeviceAnalogInputTwoFunctionSelector',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FlueGasSensorTestMode',
              isRead: 'true',
              interval: '1535',
              texttableentry: 'FlueGasSensorTestMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PrimaryCircuitWaterFlowTestMode',
              isRead: 'true',
              interval: '1536',
              texttableentry: 'PrimaryCircuitWaterFlowTestMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ChimneySweeperTestMode',
              isRead: 'true',
              interval: '1537',
              texttableentry: 'ChimneySweeperTestMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigbeeEnable',
              isRead: 'true',
              interval: '1538',
              texttableentry: 'ZigbeeEnable',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigbeeStatus',
              isRead: 'true',
              interval: '1539',
              texttableentry: 'ZigbeeStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigbeeIdentification',
              isRead: 'true',
              interval: '1540',
              texttableentry: 'ZigbeeIdentification',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_LegionellaProtectionPump',
              isRead: 'true',
              interval: '1541',
              texttableentry: 'LegionellaProtectionPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SecondaryApplicationChecksum',
              isRead: 'true',
              interval: '1546',
              texttableentry: 'SecondaryApplicationChecksum',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_InternalComponentUsage',
              isRead: 'true',
              interval: '1548',
              texttableentry: 'InternalComponentUsage',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HydraulicMatrixConfiguration',
              isRead: 'true',
              interval: '1549',
              texttableentry: 'HydraulicMatrixConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FunctionMatrix',
              isRead: 'true',
              interval: '1550',
              texttableentry: 'FunctionMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellExternalControl',
              isRead: 'true',
              interval: '1551',
              texttableentry: 'FuelCellExternalControl',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectronicControlUnitOdxVersion',
              isRead: 'true',
              interval: '1553',
              texttableentry: 'ElectronicControlUnitOdxVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HeatingSupport',
              isRead: 'true',
              interval: '1554',
              texttableentry: 'HeatingSupport',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitFixedValueFlowTemperatureSetpoint',
              isRead: 'true',
              interval: '1555',
              texttableentry: 'MixerOneCircuitFixedValueFlowTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitFixedValueFlowTemperatureSetpoint',
              isRead: 'true',
              interval: '1556',
              texttableentry: 'MixerTwoCircuitFixedValueFlowTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitFixedValueFlowTemperatureSetpoint',
              isRead: 'true',
              interval: '1557',
              texttableentry: 'MixerThreeCircuitFixedValueFlowTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitFixedValueFlowTemperatureSetpoint',
              isRead: 'true',
              interval: '1558',
              texttableentry: 'MixerFourCircuitFixedValueFlowTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFiveCircuitFixedValueFlowTemperatureSetpoint',
              isRead: 'true',
              interval: '1559',
              texttableentry: 'MixerFiveCircuitFixedValueFlowTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixCircuitFixedValueFlowTemperatureSetpoint',
              isRead: 'true',
              interval: '1560',
              texttableentry: 'MixerSixCircuitFixedValueFlowTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSevenCircuitFixedValueFlowTemperatureSetpoint',
              isRead: 'true',
              interval: '1561',
              texttableentry: 'MixerSevenCircuitFixedValueFlowTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerEightCircuitFixedValueFlowTemperatureSetpoint',
              isRead: 'true',
              interval: '1562',
              texttableentry: 'MixerEightCircuitFixedValueFlowTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SystemReturnTemperatureSensor',
              isRead: 'true',
              interval: '1573',
              texttableentry: 'SystemReturnTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_IncreasedReturnTemperatureSetpoint',
              isRead: 'true',
              interval: '1585',
              texttableentry: 'IncreasedReturnTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HeatCellCondensateDetection',
              isRead: 'true',
              interval: '1586',
              texttableentry: 'HeatCellCondensateDetection',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BufferHysteresis',
              isRead: 'true',
              interval: '1593',
              texttableentry: 'BufferHysteresis',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_LastApplicationUpdate',
              isRead: 'true',
              interval: '1594',
              texttableentry: 'LastApplicationUpdate',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ParameterIdentificationVersionFactory',
              isRead: 'true',
              interval: '1595',
              texttableentry: 'ParameterIdentificationVersionFactory',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_IncreasedReturnTemperatureSensor',
              isRead: 'true',
              interval: '1596',
              texttableentry: 'IncreasedReturnTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SolarStaticTemperatureControlHysteresis',
              isRead: 'true',
              interval: '1598',
              texttableentry: 'SolarStaticTemperatureControlHysteresis',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarSecondaryDeltaTemperatureHysteresis',
              isRead: 'true',
              interval: '1599',
              texttableentry: 'SolarSecondaryDeltaTemperatureHysteresis',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BufferDischargeFunctionThreeWayValvePositionPercent',
              isRead: 'true',
              interval: '1600',
              texttableentry: 'BufferDischargeFunctionThreeWayValvePositionPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellCondition',
              isRead: 'true',
              interval: '1601',
              texttableentry: 'FuelCellCondition',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GatewayExternalTargetFlowTemperatureSetpoint',
              isRead: 'true',
              interval: '1604',
              texttableentry: 'GatewayExternalTargetFlowTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayExternalHeatEngineTargetOperationMode',
              isRead: 'true',
              interval: '1605',
              texttableentry: 'GatewayExternalHeatEngineTargetOperationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_IntervalStrategyProperties',
              isRead: 'true',
              interval: '1606',
              texttableentry: 'IntervalStrategyProperties',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DifferentialTemperatureControllerHeatSourceTemperatureSensor',
              isRead: 'true',
              interval: '1608',
              texttableentry: 'DifferentialTemperatureControllerHeatSourceTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DifferentialTemperatureControllerHeatSinkTemperatureSensor',
              isRead: 'true',
              interval: '1609',
              texttableentry: 'DifferentialTemperatureControllerHeatSinkTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HeatingSupportBufferTemperatureSensor',
              isRead: 'true',
              interval: '1610',
              texttableentry: 'HeatingSupportBufferTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PreheatingReferenceTemperatureSensor',
              isRead: 'true',
              interval: '1611',
              texttableentry: 'PreheatingReferenceTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ExternalMixerTwoCircuitTargetOperationMode',
              isRead: 'true',
              interval: '1612',
              texttableentry: 'ExternalMixerTwoCircuitTargetOperationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalMixerThreeCircuitTargetOperationMode',
              isRead: 'true',
              interval: '1613',
              texttableentry: 'ExternalMixerThreeCircuitTargetOperationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalMixerFourCircuitTargetOperationMode',
              isRead: 'true',
              interval: '1614',
              texttableentry: 'ExternalMixerFourCircuitTargetOperationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalMixerOneCircuitFixedValueTargetTemperatureSetpoint',
              isRead: 'true',
              interval: '1627',
              texttableentry: 'ExternalMixerOneCircuitFixedValueTargetTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalMixerTwoCircuitFixedValueTargetTemperatureSetpoint',
              isRead: 'true',
              interval: '1628',
              texttableentry: 'ExternalMixerTwoCircuitFixedValueTargetTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalMixerThreeCircuitFixedValueTargetTemperatureSetpoint',
              isRead: 'true',
              interval: '1629',
              texttableentry: 'ExternalMixerThreeCircuitFixedValueTargetTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalMixerFourCircuitFixedValueTargetTemperatureSetpoint',
              isRead: 'true',
              interval: '1630',
              texttableentry: 'ExternalMixerFourCircuitFixedValueTargetTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitCurrentTemperatureSetpoint',
              isRead: 'true',
              interval: '1643',
              texttableentry: 'MixerOneCircuitCurrentTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitCurrentTemperatureSetpoint',
              isRead: 'true',
              interval: '1644',
              texttableentry: 'MixerTwoCircuitCurrentTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitCurrentTemperatureSetpoint',
              isRead: 'true',
              interval: '1645',
              texttableentry: 'MixerThreeCircuitCurrentTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitCurrentTemperatureSetpoint',
              isRead: 'true',
              interval: '1646',
              texttableentry: 'MixerFourCircuitCurrentTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EndResultDomesticHotWaterTemperatureSetpoint',
              isRead: 'true',
              interval: '1659',
              texttableentry: 'EndResultDomesticHotWaterTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SupportedFeatures',
              isRead: 'true',
              interval: '1660',
              texttableentry: 'SupportedFeatures',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SolarSecondaryTransferPump',
              isRead: 'true',
              interval: '1661',
              texttableentry: 'SolarSecondaryTransferPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HeatingSupportBufferThreeWayValvePositionPercent',
              isRead: 'true',
              interval: '1662',
              texttableentry: 'HeatingSupportBufferThreeWayValvePositionPercent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_TestStatus',
              isRead: 'true',
              interval: '1663',
              texttableentry: 'TestStatus',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitPumpOscillationTime',
              isRead: 'true',
              interval: '1667',
              texttableentry: 'MixerOneCircuitPumpOscillationTime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitPumpOscillationTime',
              isRead: 'true',
              interval: '1668',
              texttableentry: 'MixerTwoCircuitPumpOscillationTime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitPumpOscillationTime',
              isRead: 'true',
              interval: '1669',
              texttableentry: 'MixerThreeCircuitPumpOscillationTime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitPumpOscillationTime',
              isRead: 'true',
              interval: '1670',
              texttableentry: 'MixerFourCircuitPumpOscillationTime',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayEthernetEnable',
              isRead: 'true',
              interval: '1694',
              texttableentry: 'GatewayEthernetEnable',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayEthernetConfig',
              isRead: 'true',
              interval: '1695',
              texttableentry: 'GatewayEthernetConfig',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayEthernetIp',
              isRead: 'true',
              interval: '1696',
              texttableentry: 'GatewayEthernetIp',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayEthernetNetworkStatus',
              isRead: 'true',
              interval: '1697',
              texttableentry: 'GatewayEthernetNetworkStatus',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericMZIOAccessoryTwoModuleFunction',
              isRead: 'true',
              interval: '1706',
              texttableentry: 'GenericMZIOAccessoryTwoModuleFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GenericMZIOAccessoryModuleFunction',
              isRead: 'true',
              interval: '1709',
              texttableentry: 'GenericMZIOAccessoryModuleFunction',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SolarIntervalFunction',
              isRead: 'true',
              interval: '1719',
              texttableentry: 'SolarIntervalFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalInputFiveValue',
              isRead: 'true',
              interval: '1720',
              texttableentry: 'DeviceDigitalInputFiveValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_WaterPressureConfiguration',
              isRead: 'true',
              interval: '1721',
              texttableentry: 'WaterPressureConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ThermostatTerminalOneOperationMode',
              isRead: 'true',
              interval: '1722',
              texttableentry: 'ThermostatTerminalOneCircuitOperationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ThermostatTerminalTwoOperationMode',
              isRead: 'true',
              interval: '1723',
              texttableentry: 'ThermostatTerminalTwoCircuitOperationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ThermostatTerminalThreeOperationMode',
              isRead: 'true',
              interval: '1724',
              texttableentry: 'ThermostatTerminalThreeCircuitOperationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ThermostatTerminalOneDemandInput',
              isRead: 'true',
              interval: '1725',
              texttableentry: 'ThermostatTerminalOneCircuitDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ThermostatTerminalTwoDemandInput',
              isRead: 'true',
              interval: '1726',
              texttableentry: 'ThermostatTerminalTwoCircuitDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ThermostatTerminalThreeDemandInput',
              isRead: 'true',
              interval: '1727',
              texttableentry: 'ThermostatTerminalThreeCircuitDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ThermostatTerminalOneCircuitPump',
              isRead: 'true',
              interval: '1728',
              texttableentry: 'ThermostatTerminalOneCircuitPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ThermostatTerminalTwoCircuitPump',
              isRead: 'true',
              interval: '1729',
              texttableentry: 'ThermostatTerminalTwoCircuitPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ThermostatTerminalThreeCircuitPump',
              isRead: 'true',
              interval: '1730',
              texttableentry: 'ThermostatTerminalThreeCircuitPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalLockActive',
              isRead: 'true',
              interval: '1731',
              texttableentry: 'ExternalLockActive',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FixedRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '1732',
              texttableentry: 'FixedRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitDynamicRoomByRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '1733',
              texttableentry: 'MixerOneCircuitDynamicRoomByRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitDynamicRoomByRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '1734',
              texttableentry: 'MixerTwoCircuitDynamicRoomByRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitDynamicRoomByRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '1735',
              texttableentry: 'MixerThreeCircuitDynamicRoomByRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitDynamicRoomByRoomTemperatureSetpoint',
              isRead: 'true',
              interval: '1736',
              texttableentry: 'MixerFourCircuitDynamicRoomByRoomTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedModulationCurrentValueStepsAndDurationOne',
              isRead: 'true',
              interval: '1749',
              texttableentry: 'TimeSeriesRecordedModulationCurrentValueStepsAndDurationOne',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedModulationCurrentValueStepsAndDurationTwo',
              isRead: 'true',
              interval: '1750',
              texttableentry: 'TimeSeriesRecordedModulationCurrentValueStepsAndDurationTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedModulationCurrentValueStepsAndDurationThree',
              isRead: 'true',
              interval: '1751',
              texttableentry: 'TimeSeriesRecordedModulationCurrentValueStepsAndDurationThree',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedFlowTemperatureSensorStepsAndDurationOne',
              isRead: 'true',
              interval: '1752',
              texttableentry: 'TimeSeriesRecordedFlowTemperatureSensorStepsAndDurationOne',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedFlowTemperatureSensorStepsAndDurationTwo',
              isRead: 'true',
              interval: '1753',
              texttableentry: 'TimeSeriesRecordedFlowTemperatureSensorStepsAndDurationTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedFlowTemperatureSensorStepsAndDurationThree',
              isRead: 'true',
              interval: '1754',
              texttableentry: 'TimeSeriesRecordedFlowTemperatureSensorStepsAndDurationThree',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedDomesticHotWaterOutletTemperature',
              isRead: 'true',
              interval: '1759',
              texttableentry: 'TimeSeriesRecordedDomesticHotWaterOutletTemperature',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedSystemAirInletTemperature',
              isRead: 'true',
              interval: '1760',
              texttableentry: 'TimeSeriesRecordedCombustionAirInletTemperature',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedCentralHeatingPumpSpeed',
              isRead: 'true',
              interval: '1761',
              texttableentry: 'TimeSeriesRecordedCentralHeatingPumpSpeed',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_LowWaterCutOffSignalInput',
              isRead: 'true',
              interval: '1762',
              texttableentry: 'LowWaterCutOffSignalInput',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_LowGasPressureSignalInput',
              isRead: 'true',
              interval: '1763',
              texttableentry: 'LowGasPressureSignalInput',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HighGasPressureSignalInput',
              isRead: 'true',
              interval: '1764',
              texttableentry: 'HighGasPressureSignalInput',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CombustionAirInterlock',
              isRead: 'true',
              interval: '1765',
              texttableentry: 'CombustionAirInterlock',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedFlueGasTemperatureSensorStepsAndDurationOne',
              isRead: 'true',
              interval: '1777',
              texttableentry: 'TimeSeriesRecordedFlueGasTemperatureSensorStepsAndDurationOne',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedFlueGasTemperatureSensorStepsAndDurationTwo',
              isRead: 'true',
              interval: '1778',
              texttableentry: 'TimeSeriesRecordedFlueGasTemperatureSensorStepsAndDurationTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry:
                'TI_TimeSeriesRecordedFlueGasTemperatureSensorStepsAndDurationThree',
              isRead: 'true',
              interval: '1779',
              texttableentry: 'TimeSeriesRecordedFlueGasTemperatureSensorStepsAndDurationThree',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedIgnitionTimeSteps',
              isRead: 'true',
              interval: '1780',
              texttableentry: 'TimeSeriesRecordedIgnitionTimeSteps',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedCalibrationCount',
              isRead: 'true',
              interval: '1781',
              texttableentry: 'TimeSeriesRecordedCalibrationCount',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedMonitoringIonizationMaximum',
              isRead: 'true',
              interval: '1782',
              texttableentry: 'TimeSeriesRecordedMonitoringIonizationMaximum',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedHeatingBurnerStopEvents',
              isRead: 'true',
              interval: '1783',
              texttableentry: 'TimeSeriesRecordedHeatingBurnerStopEvents',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedDomesticHotWaterBurnerStopEvents',
              isRead: 'true',
              interval: '1784',
              texttableentry: 'TimeSeriesRecordedDomesticHotWaterBurnerStopEvents',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedFlameLossModulation',
              isRead: 'true',
              interval: '1785',
              texttableentry: 'TimeSeriesRecordedFlameLossModulation',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedWaterPressureStagnation',
              isRead: 'true',
              interval: '1786',
              texttableentry: 'TimeSeriesRecordedWaterPressureStagnation',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSeriesRecordedWaterPressurePeaks',
              isRead: 'true',
              interval: '1787',
              texttableentry: 'TimeSeriesRecordedWaterPressurePeaks',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CanInterfaceVersion',
              isRead: 'true',
              interval: '1788',
              texttableentry: 'CanInterfaceVersion',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiverterValveDefaultPositionConfiguration',
              isRead: 'true',
              interval: '1791',
              texttableentry: 'DiverterValveDefaultPositionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ResetElectricalEnergyHistory',
              isRead: 'true',
              interval: '1792',
              texttableentry: 'ResetElectricalEnergyHistory',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BurnerPreconditions',
              isRead: 'true',
              interval: '1793',
              texttableentry: 'BurnerPreconditions',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HeatingCircuitHeatDeficit',
              isRead: 'true',
              interval: '1794',
              texttableentry: 'HeatingCircuitHeatDeficit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellRuntimePrediction',
              isRead: 'true',
              interval: '1795',
              texttableentry: 'FuelCellRuntimePrediction',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticElectricalEnergyConsumption',
              isRead: 'true',
              interval: '1796',
              texttableentry: 'DomesticElectricalEnergyConsumption',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PredictionDomesticElectricalEnergyConsumptionNextHour',
              isRead: 'true',
              interval: '1797',
              texttableentry: 'PredictionDomesticElectricalEnergyConsumptionNextHour',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellHoursTillNextStart',
              isRead: 'true',
              interval: '1798',
              texttableentry: 'FuelCellHoursTillNextStart',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PrimaryCircuitCurrentTemperatureSetpoint',
              isRead: 'true',
              interval: '1799',
              texttableentry: 'PrimaryCircuitCurrentTemperatureSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ResetTimeSeriesRecordingGroups',
              isRead: 'true',
              interval: '1800',
              texttableentry: 'ResetTimeSeriesRecordingGroups',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarPumpConfigurationSelection',
              isRead: 'true',
              interval: '1819',
              texttableentry: 'SolarPumpConfigurationSelection',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SolarPumpCharacteristics',
              isRead: 'true',
              interval: '1820',
              texttableentry: 'SolarPumpCharacteristics',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ActivatedFeatures',
              isRead: 'true',
              interval: '2158',
              texttableentry: 'ActivatedFeatures',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitExternalHookupDemandInput',
              isRead: 'true',
              interval: '2166',
              texttableentry: 'MixerOneCircuitExternalHookupDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitExternalHookupDemandInput',
              isRead: 'true',
              interval: '2167',
              texttableentry: 'MixerTwoCircuitExternalHookupDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitExternalHookupDemandInput',
              isRead: 'true',
              interval: '2168',
              texttableentry: 'MixerThreeCircuitExternalHookupDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitExternalHookupDemandInput',
              isRead: 'true',
              interval: '2169',
              texttableentry: 'MixerFourCircuitExternalHookupDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFiveCircuitExternalHookupDemandInput',
              isRead: 'true',
              interval: '2170',
              texttableentry: 'MixerFiveCircuitExternalHookupDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixCircuitExternalHookupDemandInput',
              isRead: 'true',
              interval: '2171',
              texttableentry: 'MixerSixCircuitExternalHookupDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSevenCircuitExternalHookupDemandInput',
              isRead: 'true',
              interval: '2172',
              texttableentry: 'MixerSevenCircuitExternalHookupDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerEightCircuitExternalHookupDemandInput',
              isRead: 'true',
              interval: '2173',
              texttableentry: 'MixerEightCircuitExternalHookupDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerNineCircuitExternalHookupDemandInput',
              isRead: 'true',
              interval: '2174',
              texttableentry: 'MixerNineCircuitExternalHookupDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTenCircuitExternalHookupDemandInput',
              isRead: 'true',
              interval: '2175',
              texttableentry: 'MixerTenCircuitExternalHookupDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerElevenCircuitExternalHookupDemandInput',
              isRead: 'true',
              interval: '2176',
              texttableentry: 'MixerElevenCircuitExternalHookupDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwelveCircuitExternalHookupDemandInput',
              isRead: 'true',
              interval: '2177',
              texttableentry: 'MixerTwelveCircuitExternalHookupDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThirteenCircuitExternalHookupDemandInput',
              isRead: 'true',
              interval: '2178',
              texttableentry: 'MixerThirteenCircuitExternalHookupDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourteenCircuitExternalHookupDemandInput',
              isRead: 'true',
              interval: '2179',
              texttableentry: 'MixerFourteenCircuitExternalHookupDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFifteenCircuitExternalHookupDemandInput',
              isRead: 'true',
              interval: '2180',
              texttableentry: 'MixerFifteenCircuitExternalHookupDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixteenCircuitExternalHookupDemandInput',
              isRead: 'true',
              interval: '2181',
              texttableentry: 'MixerSixteenCircuitExternalHookupDemandInput',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterActivationControl',
              isRead: 'true',
              interval: '2215',
              texttableentry: 'DomesticHotWaterActivationControl',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterComfortModeActivation',
              isRead: 'true',
              interval: '2216',
              texttableentry: 'DomesticHotWaterComfortModeActivation',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ThermostatTerminalOneFunction',
              isRead: 'true',
              interval: '2229',
              texttableentry: 'ThermostatTerminalOneFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ThermostatTerminalTwoFunction',
              isRead: 'true',
              interval: '2230',
              texttableentry: 'ThermostatTerminalTwoFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ThermostatTerminalThreeFunction',
              isRead: 'true',
              interval: '2231',
              texttableentry: 'ThermostatTerminalThreeFunction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CascadeSystemConfiguration',
              isRead: 'true',
              interval: '2235',
              texttableentry: 'CascadeSystemConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CascadeDeviceSetpoint',
              isRead: 'true',
              interval: '2236',
              texttableentry: 'CascadeDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CascadeDeviceStatus',
              isRead: 'true',
              interval: '2237',
              texttableentry: 'CascadeDeviceStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RemoteWeatherServiceForecast',
              isRead: 'true',
              interval: '2238',
              texttableentry: 'RemoteWeatherServiceForecast',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_OutsideTemperatureSensorSource',
              isRead: 'true',
              interval: '2241',
              texttableentry: 'OutsideTemperatureSensorSource',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterTemperatureSetpointOffset',
              isRead: 'true',
              interval: '2257',
              texttableentry: 'DomesticHotWaterTemperatureSetpointOffset',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterStatus',
              isRead: 'true',
              interval: '2320',
              texttableentry: 'DomesticHotWaterStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HighLimitTestMode',
              isRead: 'true',
              interval: '2338',
              texttableentry: 'HighLimitTestMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SafetyLimiterThresholdTemperature',
              isRead: 'true',
              interval: '2339',
              texttableentry: 'SafetyLimiterThresholdTemperature',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CombustionAirInterlockSettings',
              isRead: 'true',
              interval: '2344',
              texttableentry: 'CombustionAirInterlockSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_TargetDemandHeatProducer',
              isRead: 'true',
              interval: '2353',
              texttableentry: 'TargetDemandHeatProducer',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ResetStatisticalValues',
              isRead: 'true',
              interval: '2358',
              texttableentry: 'ResetStatisticalValues',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PaddleSwitch',
              isRead: 'true',
              interval: '2382',
              texttableentry: 'PaddleSwitch',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CustomerSpecificDeviceOneName',
              isRead: 'true',
              interval: '2387',
              texttableentry: 'CustomerSpecificDeviceOneName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CustomerSpecificDeviceTwoName',
              isRead: 'true',
              interval: '2388',
              texttableentry: 'CustomerSpecificDeviceTwoName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CustomerSpecificDeviceThreeName',
              isRead: 'true',
              interval: '2389',
              texttableentry: 'CustomerSpecificDeviceThreeName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CustomerSpecificDeviceFourName',
              isRead: 'true',
              interval: '2390',
              texttableentry: 'CustomerSpecificDeviceFourName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CustomerSpecificDeviceFiveName',
              isRead: 'true',
              interval: '2391',
              texttableentry: 'CustomerSpecificDeviceFiveName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CustomerSpecificDeviceSixName',
              isRead: 'true',
              interval: '2392',
              texttableentry: 'CustomerSpecificDeviceSixName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CustomerSpecificDeviceSevenName',
              isRead: 'true',
              interval: '2393',
              texttableentry: 'CustomerSpecificDeviceSevenName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CustomerSpecificDeviceEightName',
              isRead: 'true',
              interval: '2394',
              texttableentry: 'CustomerSpecificDeviceEightName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CustomerSpecificDeviceNineName',
              isRead: 'true',
              interval: '2395',
              texttableentry: 'CustomerSpecificDeviceNineName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CustomerSpecificDeviceTenName',
              isRead: 'true',
              interval: '2396',
              texttableentry: 'CustomerSpecificDeviceTenName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CustomerSpecificDeviceElevenName',
              isRead: 'true',
              interval: '2397',
              texttableentry: 'CustomerSpecificDeviceElevenName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CustomerSpecificDeviceTwelveName',
              isRead: 'true',
              interval: '2398',
              texttableentry: 'CustomerSpecificDeviceTwelveName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CustomerSpecificDeviceThirteenName',
              isRead: 'true',
              interval: '2399',
              texttableentry: 'CustomerSpecificDeviceThirteenName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CustomerSpecificDeviceFourteenName',
              isRead: 'true',
              interval: '2400',
              texttableentry: 'CustomerSpecificDeviceFourteenName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CustomerSpecificDeviceFifteenName',
              isRead: 'true',
              interval: '2401',
              texttableentry: 'CustomerSpecificDeviceFifteenName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CustomerSpecificDeviceSixteenName',
              isRead: 'true',
              interval: '2402',
              texttableentry: 'CustomerSpecificDeviceSixteenName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitRoomEcoFunctionSettings',
              isRead: 'true',
              interval: '2426',
              texttableentry: 'MixerOneCircuitRoomEcoFunctionSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitRoomEcoFunctionSettings',
              isRead: 'true',
              interval: '2427',
              texttableentry: 'MixerTwoCircuitRoomEcoFunctionSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitRoomEcoFunctionSettings',
              isRead: 'true',
              interval: '2428',
              texttableentry: 'MixerThreeCircuitRoomEcoFunctionSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitRoomEcoFunctionSettings',
              isRead: 'true',
              interval: '2429',
              texttableentry: 'MixerFourCircuitRoomEcoFunctionSettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SupplementalHeatEngineConfiguration',
              isRead: 'true',
              interval: '2445',
              texttableentry: 'SupplementalHeatEngineConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HmiWakeupTrigger',
              isRead: 'true',
              interval: '2446',
              texttableentry: 'HmiWakeupTrigger',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CustomerSpecificDeviceName',
              isRead: 'true',
              interval: '2449',
              texttableentry: 'CustomerSpecificDeviceName',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CascadeSequenceCurrentBoiler',
              isRead: 'true',
              interval: '2450',
              texttableentry: 'CascadeSequenceCurrentBoiler',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CascadeEmergencyOperationMode',
              isRead: 'true',
              interval: '2451',
              texttableentry: 'CascadeEmergencyOperationMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CalculatedOutsideTemperature',
              isRead: 'true',
              interval: '2457',
              texttableentry: 'CalculatedOutsideTemperature',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CascadeDeviceStatusLead',
              isRead: 'true',
              interval: '2458',
              texttableentry: 'CascadeDeviceStatusLead',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeDeviceStatusLagOne',
              isRead: 'true',
              interval: '2459',
              texttableentry: 'CascadeDeviceStatusLagOne',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeDeviceStatusLagTwo',
              isRead: 'true',
              interval: '2460',
              texttableentry: 'CascadeDeviceStatusLagTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeDeviceStatusLagThree',
              isRead: 'true',
              interval: '2461',
              texttableentry: 'CascadeDeviceStatusLagThree',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeDeviceStatusLagFour',
              isRead: 'true',
              interval: '2462',
              texttableentry: 'CascadeDeviceStatusLagFour',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeDeviceStatusLagFive',
              isRead: 'true',
              interval: '2463',
              texttableentry: 'CascadeDeviceStatusLagFive',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeDeviceStatusLagSix',
              isRead: 'true',
              interval: '2464',
              texttableentry: 'CascadeDeviceStatusLagSix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeDeviceStatusLagSeven',
              isRead: 'true',
              interval: '2465',
              texttableentry: 'CascadeDeviceStatusLagSeven',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeDeviceStatusLagEight',
              isRead: 'true',
              interval: '2466',
              texttableentry: 'CascadeDeviceStatusLagEight',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeDeviceStatusLagNine',
              isRead: 'true',
              interval: '2467',
              texttableentry: 'CascadeDeviceStatusLagNine',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeDeviceStatusLagTen',
              isRead: 'true',
              interval: '2468',
              texttableentry: 'CascadeDeviceStatusLagTen',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeDeviceStatusLagEleven',
              isRead: 'true',
              interval: '2469',
              texttableentry: 'CascadeDeviceStatusLagEleven',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeDeviceStatusLagTwelve',
              isRead: 'true',
              interval: '2470',
              texttableentry: 'CascadeDeviceStatusLagTwelve',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeDeviceStatusLagThirteen',
              isRead: 'true',
              interval: '2471',
              texttableentry: 'CascadeDeviceStatusLagThirteen',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeDeviceStatusLagFourteen',
              isRead: 'true',
              interval: '2472',
              texttableentry: 'CascadeDeviceStatusLagFourteen',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeDeviceStatusLagFifteen',
              isRead: 'true',
              interval: '2473',
              texttableentry: 'CascadeDeviceStatusLagFifteen',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeCommonFlowTemperatureSensor',
              isRead: 'true',
              interval: '2474',
              texttableentry: 'CascadeCommonFlowTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeCommonFlowCurrentTemperatureSetpoint',
              isRead: 'true',
              interval: '2475',
              texttableentry: 'CascadeCommonFlowCurrentTemperatureSetpoint',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_OpenThermConfiguration',
              isRead: 'true',
              interval: '2483',
              texttableentry: 'OpenThermConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_StartUpWizardState',
              isRead: 'true',
              interval: '2490',
              texttableentry: 'StartUpWizardState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterDemandInput',
              isRead: 'true',
              interval: '2491',
              texttableentry: 'DomesticHotWaterDemandInput',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ResetStatisticalValuesDate',
              isRead: 'true',
              interval: '2497',
              texttableentry: 'ResetStatisticalValuesDate',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrixSix',
              isRead: 'true',
              interval: '2534',
              texttableentry: 'BusTopologyMatrixSix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrixSeven',
              isRead: 'true',
              interval: '2535',
              texttableentry: 'BusTopologyMatrixSeven',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrixEight',
              isRead: 'true',
              interval: '2536',
              texttableentry: 'BusTopologyMatrixEight',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrixNine',
              isRead: 'true',
              interval: '2537',
              texttableentry: 'BusTopologyMatrixNine',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrixTen',
              isRead: 'true',
              interval: '2538',
              texttableentry: 'BusTopologyMatrixTen',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FlameBurnerTwo',
              isRead: 'true',
              interval: '2551',
              texttableentry: 'FlameBurnerTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ModulationCurrentValueBurnerTwo',
              isRead: 'true',
              interval: '2552',
              texttableentry: 'ModulationCurrentValueBurnerTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HeatEngineStatisticalBurnerTwo',
              isRead: 'true',
              interval: '2553',
              texttableentry: 'HeatEngineStatisticalBurnerTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HydraulicFlapState',
              isRead: 'true',
              interval: '2564',
              texttableentry: 'HydraulicFlapState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellTestModeOne',
              isRead: 'true',
              interval: '2576',
              texttableentry: 'FuelCellTestModeOne',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellTestModeTwo',
              isRead: 'true',
              interval: '2577',
              texttableentry: 'FuelCellTestModeTwo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_OxygenProbeProcessValuesBurnerOne',
              isRead: 'true',
              interval: '2583',
              texttableentry: 'OxygenProbeProcessValuesBurnerOne',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_OxygenProbeProcessValuesBurnerTwo',
              isRead: 'true',
              interval: '2584',
              texttableentry: 'OxygenProbeProcessValuesBurnerTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_OxygenProbeProcessValuesBurnerThree',
              isRead: 'true',
              interval: '2585',
              texttableentry: 'OxygenProbeProcessValuesBurnerThree',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ProductMatrix',
              isRead: 'true',
              interval: '2593',
              texttableentry: 'ProductMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ScreedDryingActivation',
              isRead: 'true',
              interval: '2628',
              texttableentry: 'ScreedDryingActivation',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BurnerProcessDataFlags',
              isRead: 'true',
              interval: '2635',
              texttableentry: 'BurnerProcessDataFlags',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BurnerTwoProcessDataFlags',
              isRead: 'true',
              interval: '2636',
              texttableentry: 'BurnerTwoProcessDataFlags',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BurnerThreeProcessDataFlags',
              isRead: 'true',
              interval: '2637',
              texttableentry: 'BurnerThreeProcessDataFlags',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ResetHistory',
              isRead: 'true',
              interval: '2640',
              texttableentry: 'ResetHistory',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ComfortEnsuringModeProperties',
              isRead: 'true',
              interval: '2642',
              texttableentry: 'ComfortEnsuringModeProperties',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ComfortEnsuringMode',
              isRead: 'true',
              interval: '2741',
              texttableentry: 'ComfortEnsuringMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GasPressureSwitchErrorReaction',
              isRead: 'true',
              interval: '2758',
              texttableentry: 'GasPressureSwitchErrorReaction',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PrimaryCircuitPumpDeltaTemperatureValue',
              isRead: 'true',
              interval: '2761',
              texttableentry: 'PrimaryCircuitPumpDeltaTemperatureValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ErrorMessageInputSelection',
              isRead: 'true',
              interval: '2778',
              texttableentry: 'ErrorMessageInputSelection',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeltaTemperaturePumpControlSetpoint',
              isRead: 'true',
              interval: '2779',
              texttableentry: 'DeltaTemperaturePumpControlSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticHotWaterFlowRangeDwellDuration',
              isRead: 'true',
              interval: '2780',
              texttableentry: 'DomesticHotWaterFlowRangeDwellDuration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BurnerTargetTestMode',
              isRead: 'true',
              interval: '2789',
              texttableentry: 'BurnerTargetTestMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BurnerCurrentTestMode',
              isRead: 'true',
              interval: '2790',
              texttableentry: 'BurnerCurrentTestMode',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PumpMinSpeedConfiguration',
              isRead: 'true',
              interval: '2809',
              texttableentry: 'PumpMinSpeedConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CentralHeatingPumpFeedbackSignalHandlingMode',
              isRead: 'true',
              interval: '2810',
              texttableentry: 'CentralHeatingPumpFeedbackSignalHandlingMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CascadeOxygenStatisticsLagOne',
              isRead: 'true',
              interval: '2811',
              texttableentry: 'CascadeOxygenStatisticsLagOne',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeOxygenStatisticsLagTwo',
              isRead: 'true',
              interval: '2812',
              texttableentry: 'CascadeOxygenStatisticsLagTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeOxygenStatisticsLagThree',
              isRead: 'true',
              interval: '2813',
              texttableentry: 'CascadeOxygenStatisticsLagThree',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeOxygenStatisticsLagFour',
              isRead: 'true',
              interval: '2814',
              texttableentry: 'CascadeOxygenStatisticsLagFour',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeOxygenStatisticsLagFive',
              isRead: 'true',
              interval: '2815',
              texttableentry: 'CascadeOxygenStatisticsLagFive',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeOxygenStatisticsLagSix',
              isRead: 'true',
              interval: '2816',
              texttableentry: 'CascadeOxygenStatisticsLagSix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeOxygenStatisticsLagSeven',
              isRead: 'true',
              interval: '2817',
              texttableentry: 'CascadeOxygenStatisticsLagSeven',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeOxygenStatisticsLagEight',
              isRead: 'true',
              interval: '2818',
              texttableentry: 'CascadeOxygenStatisticsLagEight',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeOxygenStatisticsLagNine',
              isRead: 'true',
              interval: '2819',
              texttableentry: 'CascadeOxygenStatisticsLagNine',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeOxygenStatisticsLagTen',
              isRead: 'true',
              interval: '2820',
              texttableentry: 'CascadeOxygenStatisticsLagTen',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeOxygenStatisticsLagEleven',
              isRead: 'true',
              interval: '2821',
              texttableentry: 'CascadeOxygenStatisticsLagEleven',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeOxygenStatisticsLagTwelve',
              isRead: 'true',
              interval: '2822',
              texttableentry: 'CascadeOxygenStatisticsLagTwelve',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeOxygenStatisticsLagThirteen',
              isRead: 'true',
              interval: '2823',
              texttableentry: 'CascadeOxygenStatisticsLagThirteen',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeOxygenStatisticsLagFouteen',
              isRead: 'true',
              interval: '2824',
              texttableentry: 'CascadeOxygenStatisticsLagFouteen',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CascadeOxygenStatisticsLagFifteen',
              isRead: 'true',
              interval: '2825',
              texttableentry: 'CascadeOxygenStatisticsLagFifteen',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellNetworkSystemProtectionErrorHistory',
              isRead: 'true',
              interval: '2826',
              texttableentry: 'FuelCellNetworkSystemProtectionErrorHistory',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellNetworkSystemProtectionParameters',
              isRead: 'true',
              interval: '2827',
              texttableentry: 'FuelCellNetworkSystemProtectionParameters',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellSdCardRecording',
              isRead: 'true',
              interval: '2828',
              texttableentry: 'FuelCellSdCardRecording',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EmergencyMode',
              isRead: 'true',
              interval: '2830',
              texttableentry: 'EmergencyMode',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MixerOneCircuitFrostProtectionConfiguration',
              isRead: 'true',
              interval: '2855',
              texttableentry: 'MixerOneCircuitFrostProtectionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwoCircuitFrostProtectionConfiguration',
              isRead: 'true',
              interval: '2856',
              texttableentry: 'MixerTwoCircuitFrostProtectionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThreeCircuitFrostProtectionConfiguration',
              isRead: 'true',
              interval: '2857',
              texttableentry: 'MixerThreeCircuitFrostProtectionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourCircuitFrostProtectionConfiguration',
              isRead: 'true',
              interval: '2858',
              texttableentry: 'MixerFourCircuitFrostProtectionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFiveCircuitFrostProtectionConfiguration',
              isRead: 'true',
              interval: '2859',
              texttableentry: 'MixerFiveCircuitFrostProtectionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixCircuitFrostProtectionConfiguration',
              isRead: 'true',
              interval: '2860',
              texttableentry: 'MixerSixCircuitFrostProtectionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSevenCircuitFrostProtectionConfiguration',
              isRead: 'true',
              interval: '2861',
              texttableentry: 'MixerSevenCircuitFrostProtectionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerEightCircuitFrostProtectionConfiguration',
              isRead: 'true',
              interval: '2862',
              texttableentry: 'MixerEightCircuitFrostProtectionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerNineCircuitFrostProtectionConfiguration',
              isRead: 'true',
              interval: '2863',
              texttableentry: 'MixerNineCircuitFrostProtectionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTenCircuitFrostProtectionConfiguration',
              isRead: 'true',
              interval: '2864',
              texttableentry: 'MixerTenCircuitFrostProtectionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerElevenCircuitFrostProtectionConfiguration',
              isRead: 'true',
              interval: '2865',
              texttableentry: 'MixerElevenCircuitFrostProtectionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerTwelveCircuitFrostProtectionConfiguration',
              isRead: 'true',
              interval: '2866',
              texttableentry: 'MixerTwelveCircuitFrostProtectionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerThirteenCircuitFrostProtectionConfiguration',
              isRead: 'true',
              interval: '2867',
              texttableentry: 'MixerThirteenCircuitFrostProtectionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFourteenCircuitFrostProtectionConfiguration',
              isRead: 'true',
              interval: '2868',
              texttableentry: 'MixerFourteenCircuitFrostProtectionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerFifteenCircuitFrostProtectionConfiguration',
              isRead: 'true',
              interval: '2869',
              texttableentry: 'MixerFifteenCircuitFrostProtectionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_MixerSixteenCircuitFrostProtectionConfiguration',
              isRead: 'true',
              interval: '2870',
              texttableentry: 'MixerSixteenCircuitFrostProtectionConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SystemPumpConfiguration',
              isRead: 'true',
              interval: '2937',
              texttableentry: 'SystemPumpConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CascadeSystemPump',
              isRead: 'true',
              interval: '2938',
              texttableentry: 'CascadeSystemPump',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellFuelProcessorTemperatures',
              isRead: 'true',
              interval: '2954',
              texttableentry: 'FuelCellFuelProcessorTemperatures',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellFuelProcessorProcessWater',
              isRead: 'true',
              interval: '2955',
              texttableentry: 'FuelCellFuelProcessorProcessWater',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ModulationCurrentValueBurnerOne',
              isRead: 'true',
              interval: '2958',
              texttableentry: 'ModulationCurrentValueBurnerOne',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ModulationTargetSetpointBurnerOne',
              isRead: 'true',
              interval: '2959',
              texttableentry: 'ModulationTargetSetpointBurnerOne',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ModulationTargetSetpointBurnerTwo',
              isRead: 'true',
              interval: '2960',
              texttableentry: 'ModulationTargetSetpointBurnerTwo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FlameBurnerOne',
              isRead: 'true',
              interval: '2961',
              texttableentry: 'FlameBurnerOne',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_HeatEngineStatisticalBurnerOne',
              isRead: 'true',
              interval: '2962',
              texttableentry: 'HeatEngineStatisticalBurnerOne',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectronicControlUnitSafeStateStatus',
              isRead: 'true',
              interval: '2969',
              texttableentry: 'ElectronicControlUnitSafeStateStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellExtendedStatusInformation',
              isRead: 'true',
              interval: '2970',
              texttableentry: 'FuelCellExtendedStatusInformation',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellFuelProcessorOperatingTimeReset',
              isRead: 'true',
              interval: '2971',
              texttableentry: 'FuelCellFuelProcessorOperatingTimeReset',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ThirdPartyDeviceSoftwareInformation',
              isRead: 'true',
              interval: '2972',
              texttableentry: 'ThirdPartyDeviceSoftwareInformation',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellExtendedCounters',
              isRead: 'true',
              interval: '2973',
              texttableentry: 'FuelCellExtendedCounters',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellPrimaryPumpSpeed',
              isRead: 'true',
              interval: '2974',
              texttableentry: 'FuelCellPrimaryPumpSpeed',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellElectricalPowerOutputNet',
              isRead: 'true',
              interval: '2975',
              texttableentry: 'FuelCellElectricalPowerOutputNet',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellControlSequenceNumber',
              isRead: 'true',
              interval: '2976',
              texttableentry: 'FuelCellControlSequenceNumber',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellSystemSeparationCircuitVolumeFlow',
              isRead: 'true',
              interval: '2977',
              texttableentry: 'FuelCellSystemSeparationCircuitVolumeFlow',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellInverter',
              isRead: 'true',
              interval: '2978',
              texttableentry: 'FuelCellInverter',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellHousing',
              isRead: 'true',
              interval: '2979',
              texttableentry: 'FuelCellHousing',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellGas',
              isRead: 'true',
              interval: '2980',
              texttableentry: 'FuelCellGas',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellAirStackPreferentialOxidation',
              isRead: 'true',
              interval: '2981',
              texttableentry: 'FuelCellAirStackPreferentialOxidation',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellFuelProcessorBurner',
              isRead: 'true',
              interval: '2982',
              texttableentry: 'FuelCellFuelProcessorBurner',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellExhaustGas',
              isRead: 'true',
              interval: '2983',
              texttableentry: 'FuelCellExhaustGas',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FuelCellStack',
              isRead: 'true',
              interval: '2984',
              texttableentry: 'FuelCellStack',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_CondensateBlockageDetection',
              isRead: 'true',
              interval: '3011',
              texttableentry: 'CondensateBlockageDetection',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellServiceMemory',
              isRead: 'true',
              interval: '3012',
              texttableentry: 'FuelCellServiceMemory',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticThermalEnergyConsumptionHeatingCircuit',
              isRead: 'true',
              interval: '3020',
              texttableentry: 'DomesticThermalEnergyConsumptionHeatingCircuit',
              isWrite: 'false',
            },
            {
              TI_texttableentry:
                'TI_PredictionDomesticThermalEnergyConsumptionHeatingCircuitNextHour',
              isRead: 'true',
              interval: '3021',
              texttableentry: 'PredictionDomesticThermalEnergyConsumptionHeatingCircuitNextHour',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DomesticElectricalEnergyConsumptionHistory',
              isRead: 'true',
              interval: '3022',
              texttableentry: 'DomesticElectricalEnergyConsumptionHistory',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DomesticThermalEnergyConsumptionHeatingCircuitHistory',
              isRead: 'true',
              interval: '3023',
              texttableentry: 'DomesticThermalEnergyConsumptionHeatingCircuitHistory',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RunTimeSinceLastStartUp',
              isRead: 'true',
              interval: '3024',
              texttableentry: 'RunTimeSinceLastStartUp',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellDiverterValveStatisticalCounterDomesticHotWater',
              isRead: 'true',
              interval: '3025',
              texttableentry: 'FuelCellDiverterValveStatisticalCounterDomesticHotWater',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellDiverterValveStatisticalCounterHeatingCircuit',
              isRead: 'true',
              interval: '3026',
              texttableentry: 'FuelCellDiverterValveStatisticalCounterHeatingCircuit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellDiverterValveStatisticalDurationDomesticHotWater',
              isRead: 'true',
              interval: '3027',
              texttableentry: 'FuelCellDiverterValveStatisticalDurationDomesticHotWater',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FuelCellDiverterValveStatisticalDurationHeatingCircuit',
              isRead: 'true',
              interval: '3028',
              texttableentry: 'FuelCellDiverterValveStatisticalDurationHeatingCircuit',
              isWrite: 'true',
            },
          ],
        },
      ],
    };
  }
}
